// Autogenerated by scripts/graphql/generate_all_fragments.py. Do not edit.

import {DocumentNode} from 'graphql';

import AnalysisChipOrInaccessibleGraphQL from '../../../graphql-fragments/analysis-tool/AnalysisChipOrInaccessible.graphql';
import AnalysisSearchAttributesGraphQL from '../../../graphql-fragments/analysis-tool/AnalysisSearchAttributes.graphql';
import AnalysisTemplateChipOrInaccessibleGraphQL from '../../../graphql-fragments/analysis-tool/AnalysisTemplateChipOrInaccessible.graphql';
import AnalyticsTrackingParamsGraphQL from '../../../graphql-fragments/analytics/AnalyticsTrackingParams.graphql';
import AntibodyFormatGraphQL from '../../../graphql-fragments/antibodies/AntibodyFormat.graphql';
import AntibodySchemaWithFormatGraphQL from '../../../graphql-fragments/antibodies/AntibodySchemaWithFormat.graphql';
import ImplementedAntibodySchemaInterfaceGraphQL from '../../../graphql-fragments/antibodies/ImplementedAntibodySchemaInterface.graphql';
import JellyfishGraphQL from '../../../graphql-fragments/app-core/archetype/Jellyfish.graphql';
import JellyfishFileStateGraphQL from '../../../graphql-fragments/app-core/archetype/JellyfishFileState.graphql';
import JellyfishListingGraphQL from '../../../graphql-fragments/app-core/archetype/JellyfishListing.graphql';
import JellyfishPermissionsGraphQL from '../../../graphql-fragments/app-core/archetype/JellyfishPermissions.graphql';
import ArchiveDataGraphQL from '../../../graphql-fragments/app-core/platform/archivable/ArchiveData.graphql';
import ArchiveRecordGraphQL from '../../../graphql-fragments/app-core/platform/archivable/ArchiveRecord.graphql';
import CoreObjectArchivableGraphQL from '../../../graphql-fragments/app-core/platform/archivable/CoreObjectArchivable.graphql';
import HasListingPermissionsGraphQL from '../../../graphql-fragments/app-core/platform/permissionable/HasListingPermissions.graphql';
import StarGraphQL from '../../../graphql-fragments/app-core/platform/starrable/Star.graphql';
import StarrableGraphQL from '../../../graphql-fragments/app-core/platform/starrable/Starrable.graphql';
import HasArchiveRecordGraphQL from '../../../graphql-fragments/archive/HasArchiveRecord.graphql';
import HasArchiveRecordREST from '../../../graphql-fragments/archive/HasArchiveRecord.rest.json5';
import AllAssaySchemasGraphQL from '../../../graphql-fragments/assays/AllAssaySchemas.graphql';
import AllAssaySchemasREST from '../../../graphql-fragments/assays/AllAssaySchemas.rest.json5';
import AssaySchemaGraphQL from '../../../graphql-fragments/assays/AssaySchema.graphql';
import AssaySchemaREST from '../../../graphql-fragments/assays/AssaySchema.rest.json5';
import CollaboratorInfoGraphQL from '../../../graphql-fragments/auth/CollaboratorInfo.graphql';
import DefaultSchemaCollaboratorsConfigurationGraphQL from '../../../graphql-fragments/auth/DefaultSchemaCollaboratorsConfiguration.graphql';
import HasOwnablePermissionsGraphQL from '../../../graphql-fragments/auth/HasOwnablePermissions.graphql';
import InaccessibleInfoGraphQL from '../../../graphql-fragments/auth/InaccessibleInfo.graphql';
import InaccessibleInfoREST from '../../../graphql-fragments/auth/InaccessibleInfo.rest.json5';
import ListingPermissionsGraphQL from '../../../graphql-fragments/auth/ListingPermissions.graphql';
import OwnerAndCollaboratorInfoGraphQL from '../../../graphql-fragments/auth/OwnerAndCollaboratorInfo.graphql';
import BasePermissionsGraphQL from '../../../graphql-fragments/auth/platform/BasePermissions.graphql';
import BenchlingAppGraphQL from '../../../graphql-fragments/benchling-apps/BenchlingApp.graphql';
import BenchlingAppCanvasGraphQL from '../../../graphql-fragments/benchling-apps/BenchlingAppCanvas.graphql';
import BenchlingAppConfigurationGraphQL from '../../../graphql-fragments/benchling-apps/BenchlingAppConfiguration.graphql';
import BenchlingAppDefinitionGraphQL from '../../../graphql-fragments/benchling-apps/BenchlingAppDefinition.graphql';
import BenchlingAppDefinitionVersionsGraphQL from '../../../graphql-fragments/benchling-apps/BenchlingAppDefinitionVersions.graphql';
import BenchlingAppFeatureGraphQL from '../../../graphql-fragments/benchling-apps/BenchlingAppFeature.graphql';
import BenchlingAppSessionGraphQL from '../../../graphql-fragments/benchling-apps/BenchlingAppSession.graphql';
import ResourceFeatureAssociationGraphQL from '../../../graphql-fragments/benchling-apps/ResourceFeatureAssociation.graphql';
import IndividualColumnMappingGraphQL from '../../../graphql-fragments/bulk-adapters/IndividualColumnMapping.graphql';
import SpreadsheetColumnsMappingGraphQL from '../../../graphql-fragments/bulk-adapters/SpreadsheetColumnsMapping.graphql';
import CanvasDefinitionFileStateGraphQL from '../../../graphql-fragments/canvas-core/CanvasDefinitionFileState.graphql';
import CanvasVersionFileStateGraphQL from '../../../graphql-fragments/canvas-core/CanvasVersionFileState.graphql';
import MoleculeGraphQL from '../../../graphql-fragments/chemistry/Molecule.graphql';
import MoleculeSummaryGraphQL from '../../../graphql-fragments/chemistry/MoleculeSummary.graphql';
import MoleculeSummaryREST from '../../../graphql-fragments/chemistry/MoleculeSummary.rest.json5';
import MoleculeVersionGraphQL from '../../../graphql-fragments/chemistry/MoleculeVersion.graphql';
import ReactionGraphQL from '../../../graphql-fragments/chemistry/Reaction.graphql';
import UpdateMoleculeVersionResponseGraphQL from '../../../graphql-fragments/chemistry/UpdateMoleculeVersionResponse.graphql';
import DatasetGraphQL from '../../../graphql-fragments/data-frames/Dataset.graphql';
import DatasetChipGraphQL from '../../../graphql-fragments/data-frames/DatasetChip.graphql';
import DatasetChipOrInaccessibleGraphQL from '../../../graphql-fragments/data-frames/DatasetChipOrInaccessible.graphql';
import DatasetListingGraphQL from '../../../graphql-fragments/data-frames/DatasetListing.graphql';
import DatasetPermissionsGraphQL from '../../../graphql-fragments/data-frames/DatasetPermissions.graphql';
import PersistedDataFrameGraphQL from '../../../graphql-fragments/data-frames/PersistedDataFrame.graphql';
import EventSubscriptionGraphQL from '../../../graphql-fragments/events/EventSubscription.graphql';
import FileGraphQL from '../../../graphql-fragments/files/File.graphql';
import FileChipGraphQL from '../../../graphql-fragments/files/FileChip.graphql';
import FileChipOrInaccessibleGraphQL from '../../../graphql-fragments/files/FileChipOrInaccessible.graphql';
import FileListingGraphQL from '../../../graphql-fragments/files/FileListing.graphql';
import FilePermissionsGraphQL from '../../../graphql-fragments/files/FilePermissions.graphql';
import ScratchFileGraphQL from '../../../graphql-fragments/files/ScratchFile.graphql';
import AnalyticsDashboardLinkGraphQL from '../../../graphql-fragments/insights/AnalyticsDashboardLink.graphql';
import AnalyticsDashboardLinkParentGraphQL from '../../../graphql-fragments/insights/AnalyticsDashboardLinkParent.graphql';
import AnalyticsDashboardListingGraphQL from '../../../graphql-fragments/insights/AnalyticsDashboardListing.graphql';
import AnalyticsDashboardSearchAttributesGraphQL from '../../../graphql-fragments/insights/AnalyticsDashboardSearchAttributes.graphql';
import AnalyticsParameterBioentityLinkConfigGraphQL from '../../../graphql-fragments/insights/AnalyticsParameterBioentityLinkConfig.graphql';
import AnalyticsParameterConfigGraphQL from '../../../graphql-fragments/insights/AnalyticsParameterConfig.graphql';
import AnalyticsParameterDateConfigGraphQL from '../../../graphql-fragments/insights/AnalyticsParameterDateConfig.graphql';
import AnalyticsParameterEntryLinkConfigGraphQL from '../../../graphql-fragments/insights/AnalyticsParameterEntryLinkConfig.graphql';
import AnalyticsParameterFolderLinkConfigGraphQL from '../../../graphql-fragments/insights/AnalyticsParameterFolderLinkConfig.graphql';
import AnalyticsParameterNumberConfigGraphQL from '../../../graphql-fragments/insights/AnalyticsParameterNumberConfig.graphql';
import AnalyticsParameterProcessLinkConfigGraphQL from '../../../graphql-fragments/insights/AnalyticsParameterProcessLinkConfig.graphql';
import AnalyticsParameterProcessTaskLinkConfigGraphQL from '../../../graphql-fragments/insights/AnalyticsParameterProcessTaskLinkConfig.graphql';
import AnalyticsParameterProjectLinkConfigGraphQL from '../../../graphql-fragments/insights/AnalyticsParameterProjectLinkConfig.graphql';
import AnalyticsParameterSelectorConfigGraphQL from '../../../graphql-fragments/insights/AnalyticsParameterSelectorConfig.graphql';
import AnalyticsParameterStorableLinkConfigGraphQL from '../../../graphql-fragments/insights/AnalyticsParameterStorableLinkConfig.graphql';
import AnalyticsParameterStringConfigGraphQL from '../../../graphql-fragments/insights/AnalyticsParameterStringConfig.graphql';
import AnalyticsParameterStudyLinkConfigGraphQL from '../../../graphql-fragments/insights/AnalyticsParameterStudyLinkConfig.graphql';
import AnalyticsParameterTeamLinkConfigGraphQL from '../../../graphql-fragments/insights/AnalyticsParameterTeamLinkConfig.graphql';
import AnalyticsParameterUserLinkConfigGraphQL from '../../../graphql-fragments/insights/AnalyticsParameterUserLinkConfig.graphql';
import AnalyticsParameterValueTemplateGraphQL from '../../../graphql-fragments/insights/AnalyticsParameterValueTemplate.graphql';
import BaseAnalyticsParameterConfigGraphQL from '../../../graphql-fragments/insights/BaseAnalyticsParameterConfig.graphql';
import InstitutionGraphQL from '../../../graphql-fragments/institutions/Institution.graphql';
import ConnectionChipOrInaccessibleGraphQL from '../../../graphql-fragments/instruments/ConnectionChipOrInaccessible.graphql';
import ConnectionListingGraphQL from '../../../graphql-fragments/instruments/ConnectionListing.graphql';
import BaseStorableGraphQL from '../../../graphql-fragments/inventory/BaseStorable.graphql';
import BaseStorableREST from '../../../graphql-fragments/inventory/BaseStorable.rest.json5';
import BaseStorableSummaryGraphQL from '../../../graphql-fragments/inventory/BaseStorableSummary.graphql';
import BaseStorableSummaryREST from '../../../graphql-fragments/inventory/BaseStorableSummary.rest.json5';
import BatchGraphQL from '../../../graphql-fragments/inventory/batches/Batch.graphql';
import BatchSummaryGraphQL from '../../../graphql-fragments/inventory/batches/BatchSummary.graphql';
import BoxGraphQL from '../../../graphql-fragments/inventory/Box.graphql';
import BoxLiveDataGraphQL from '../../../graphql-fragments/inventory/BoxLiveData.graphql';
import BoxSummaryGraphQL from '../../../graphql-fragments/inventory/BoxSummary.graphql';
import BoxSummaryREST from '../../../graphql-fragments/inventory/BoxSummary.rest.json5';
import ContainerGraphQL from '../../../graphql-fragments/inventory/Container.graphql';
import ContainerREST from '../../../graphql-fragments/inventory/Container.rest.json5';
import ContainerInfoGraphQL from '../../../graphql-fragments/inventory/ContainerInfo.graphql';
import ContainerSummaryGraphQL from '../../../graphql-fragments/inventory/ContainerSummary.graphql';
import ContainerSummaryREST from '../../../graphql-fragments/inventory/ContainerSummary.rest.json5';
import GridGraphQL from '../../../graphql-fragments/inventory/Grid.graphql';
import GridCellIndexesGraphQL from '../../../graphql-fragments/inventory/GridCellIndexes.graphql';
import InventoryContainerLiveDataGraphQL from '../../../graphql-fragments/inventory/InventoryContainerLiveData.graphql';
import LocationGraphQL from '../../../graphql-fragments/inventory/Location.graphql';
import LocationSummaryGraphQL from '../../../graphql-fragments/inventory/LocationSummary.graphql';
import LocationSummaryREST from '../../../graphql-fragments/inventory/LocationSummary.rest.json5';
import LookupStorableGraphQL from '../../../graphql-fragments/inventory/LookupStorable.graphql';
import ParentStorableGraphQL from '../../../graphql-fragments/inventory/ParentStorable.graphql';
import ParentStorableCapacityGraphQL from '../../../graphql-fragments/inventory/ParentStorableCapacity.graphql';
import PlateGraphQL from '../../../graphql-fragments/inventory/Plate.graphql';
import PlateLiveDataGraphQL from '../../../graphql-fragments/inventory/PlateLiveData.graphql';
import PlateSizeGraphQL from '../../../graphql-fragments/inventory/PlateSize.graphql';
import PlateSummaryGraphQL from '../../../graphql-fragments/inventory/PlateSummary.graphql';
import PlateSummaryREST from '../../../graphql-fragments/inventory/PlateSummary.rest.json5';
import PlateWellInfoGraphQL from '../../../graphql-fragments/inventory/PlateWellInfo.graphql';
import PrinterGraphQL from '../../../graphql-fragments/inventory/Printer.graphql';
import SampleRolesGraphQL from '../../../graphql-fragments/inventory/SampleRoles.graphql';
import SampleRolesREST from '../../../graphql-fragments/inventory/SampleRoles.rest.json5';
import AllBoxSchemasGraphQL from '../../../graphql-fragments/inventory/schemas/AllBoxSchemas.graphql';
import AllBoxSchemasREST from '../../../graphql-fragments/inventory/schemas/AllBoxSchemas.rest.json5';
import AllContainerSchemasGraphQL from '../../../graphql-fragments/inventory/schemas/AllContainerSchemas.graphql';
import AllContainerSchemasREST from '../../../graphql-fragments/inventory/schemas/AllContainerSchemas.rest.json5';
import AllLocationSchemasGraphQL from '../../../graphql-fragments/inventory/schemas/AllLocationSchemas.graphql';
import AllLocationSchemasREST from '../../../graphql-fragments/inventory/schemas/AllLocationSchemas.rest.json5';
import AllPlateSchemasGraphQL from '../../../graphql-fragments/inventory/schemas/AllPlateSchemas.graphql';
import AllPlateSchemasREST from '../../../graphql-fragments/inventory/schemas/AllPlateSchemas.rest.json5';
import AllStorableSchemasGraphQL from '../../../graphql-fragments/inventory/schemas/AllStorableSchemas.graphql';
import BaseStorableSchemaGraphQL from '../../../graphql-fragments/inventory/schemas/BaseStorableSchema.graphql';
import BaseStorableSchemaREST from '../../../graphql-fragments/inventory/schemas/BaseStorableSchema.rest.json5';
import BoxSchemaGraphQL from '../../../graphql-fragments/inventory/schemas/BoxSchema.graphql';
import BoxSchemaREST from '../../../graphql-fragments/inventory/schemas/BoxSchema.rest.json5';
import ContainerSchemaGraphQL from '../../../graphql-fragments/inventory/schemas/ContainerSchema.graphql';
import ContainerSchemaREST from '../../../graphql-fragments/inventory/schemas/ContainerSchema.rest.json5';
import LocationSchemaGraphQL from '../../../graphql-fragments/inventory/schemas/LocationSchema.graphql';
import LocationSchemaREST from '../../../graphql-fragments/inventory/schemas/LocationSchema.rest.json5';
import PlateSchemaGraphQL from '../../../graphql-fragments/inventory/schemas/PlateSchema.graphql';
import PlateSchemaREST from '../../../graphql-fragments/inventory/schemas/PlateSchema.rest.json5';
import StorableSchemaGraphQL from '../../../graphql-fragments/inventory/schemas/StorableSchema.graphql';
import StorableSchemaREST from '../../../graphql-fragments/inventory/schemas/StorableSchema.rest.json5';
import StorableSchemaChipOrInaccessibleGraphQL from '../../../graphql-fragments/inventory/schemas/StorableSchemaChipOrInaccessible.graphql';
import StorableGraphQL from '../../../graphql-fragments/inventory/Storable.graphql';
import StorableChipOrInaccessibleGraphQL from '../../../graphql-fragments/inventory/StorableChipOrInaccessible.graphql';
import StorableChipSummaryGraphQL from '../../../graphql-fragments/inventory/StorableChipSummary.graphql';
import StorableSummaryGraphQL from '../../../graphql-fragments/inventory/StorableSummary.graphql';
import AutomationErrorFileGraphQL from '../../../graphql-fragments/lab-automation/AutomationErrorFile.graphql';
import AutomationInputFileGraphQL from '../../../graphql-fragments/lab-automation/AutomationInputFile.graphql';
import AutomationOutputFileGraphQL from '../../../graphql-fragments/lab-automation/AutomationOutputFile.graphql';
import AutomationOutputFileChipOrInaccessibleGraphQL from '../../../graphql-fragments/lab-automation/AutomationOutputFileChipOrInaccessible.graphql';
import AutomationOutputFileConfigGraphQL from '../../../graphql-fragments/lab-automation/AutomationOutputFileConfig.graphql';
import AutomationOutputFileConfigREST from '../../../graphql-fragments/lab-automation/AutomationOutputFileConfig.rest.json5';
import ComplexPolymerGraphQL from '../../../graphql-fragments/modbio/complex-polymers/ComplexPolymer.graphql';
import ComplexPolymerSchemaConfigurationGraphQL from '../../../graphql-fragments/modbio/complex-polymers/ComplexPolymerSchemaConfiguration.graphql';
import OligoConjugateSchemaConfigurationGraphQL from '../../../graphql-fragments/modbio/complex-polymers/OligoConjugateSchemaConfiguration.graphql';
import OligoDuplexSchemaConfigurationGraphQL from '../../../graphql-fragments/modbio/complex-polymers/OligoDuplexSchemaConfiguration.graphql';
import ComplexPolymerConnectionGraphQL from '../../../graphql-fragments/modbio/ComplexPolymerConnection.graphql';
import ModifiedNucleotideGraphQL from '../../../graphql-fragments/modbio/ModifiedNucleotide.graphql';
import MoleculeInComplexPolymerGraphQL from '../../../graphql-fragments/modbio/MoleculeInComplexPolymer.graphql';
import NucleotideInComplexPolymerGraphQL from '../../../graphql-fragments/modbio/NucleotideInComplexPolymer.graphql';
import OligoStrandGraphQL from '../../../graphql-fragments/modbio/OligoStrand.graphql';
import ResolvedAttachmentGraphQL from '../../../graphql-fragments/modbio/ResolvedAttachment.graphql';
import PredictionBatchListingGraphQL from '../../../graphql-fragments/model-hub/PredictionBatchListing.graphql';
import PredictionJobListingGraphQL from '../../../graphql-fragments/model-hub/PredictionJobListing.graphql';
import BulkAssemblyChipOrInaccessibleGraphQL from '../../../graphql-fragments/molbio/bulk-assembly/BulkAssemblyChipOrInaccessible.graphql';
import BulkAssemblyChipSummaryGraphQL from '../../../graphql-fragments/molbio/bulk-assembly/BulkAssemblyChipSummary.graphql';
import BulkAssemblyGraphQL from '../../../graphql-fragments/molbio/BulkAssembly.graphql';
import BulkAssemblyListingGraphQL from '../../../graphql-fragments/molbio/BulkAssemblyListing.graphql';
import ProteinGraphQL from '../../../graphql-fragments/molbio/Protein.graphql';
import ProteinAlignmentSummaryGraphQL from '../../../graphql-fragments/molbio/ProteinAlignmentSummary.graphql';
import ProteinSummaryGraphQL from '../../../graphql-fragments/molbio/ProteinSummary.graphql';
import ProteinSummaryREST from '../../../graphql-fragments/molbio/ProteinSummary.rest.json5';
import SequenceGraphQL from '../../../graphql-fragments/molbio/Sequence.graphql';
import SequenceAnalysisSummaryGraphQL from '../../../graphql-fragments/molbio/SequenceAnalysisSummary.graphql';
import SequenceSummaryGraphQL from '../../../graphql-fragments/molbio/SequenceSummary.graphql';
import SequenceSummaryREST from '../../../graphql-fragments/molbio/SequenceSummary.rest.json5';
import BaseFolderItemFileGraphQL from '../../../graphql-fragments/nav/folder-items/BaseFolderItemFile.graphql';
import BasicFolderItemGraphQL from '../../../graphql-fragments/nav/folder-items/BasicFolderItem.graphql';
import BasicFolderItemSummaryGraphQL from '../../../graphql-fragments/nav/folder-items/BasicFolderItemSummary.graphql';
import BasicFolderItemSummaryREST from '../../../graphql-fragments/nav/folder-items/BasicFolderItemSummary.rest.json5';
import FolderItemSummaryGraphQL from '../../../graphql-fragments/nav/folder-items/FolderItemSummary.graphql';
import FolderItemSummaryREST from '../../../graphql-fragments/nav/folder-items/FolderItemSummary.rest.json5';
import UpdateFolderItemTagsGraphQL from '../../../graphql-fragments/nav/folder-items/UpdateFolderItemTags.graphql';
import UpdateFolderItemTagSchemaGraphQL from '../../../graphql-fragments/nav/folder-items/UpdateFolderItemTagSchema.graphql';
import FolderGraphQL from '../../../graphql-fragments/nav/folders/Folder.graphql';
import FolderREST from '../../../graphql-fragments/nav/folders/Folder.rest.json5';
import FolderSummaryGraphQL from '../../../graphql-fragments/nav/folders/FolderSummary.graphql';
import FolderSummaryREST from '../../../graphql-fragments/nav/folders/FolderSummary.rest.json5';
import FolderSummaryWithoutParentsWithoutSourceGraphQL from '../../../graphql-fragments/nav/folders/FolderSummaryWithoutParentsWithoutSource.graphql';
import FolderSummaryWithoutParentsWithoutSourceREST from '../../../graphql-fragments/nav/folders/FolderSummaryWithoutParentsWithoutSource.rest.json5';
import FolderSummaryWithoutSourceGraphQL from '../../../graphql-fragments/nav/folders/FolderSummaryWithoutSource.graphql';
import FolderSummaryWithoutSourceREST from '../../../graphql-fragments/nav/folders/FolderSummaryWithoutSource.rest.json5';
import FolderWithPermissionsGraphQL from '../../../graphql-fragments/nav/folders/FolderWithPermissions.graphql';
import FolderWithPermissionsREST from '../../../graphql-fragments/nav/folders/FolderWithPermissions.rest.json5';
import NavStoreProjectGraphQL from '../../../graphql-fragments/nav/NavStoreProject.graphql';
import NavStoreRegistryGraphQL from '../../../graphql-fragments/nav/NavStoreRegistry.graphql';
import NavStoreRegistryREST from '../../../graphql-fragments/nav/NavStoreRegistry.rest.json5';
import NavStoreSourceGraphQL from '../../../graphql-fragments/nav/NavStoreSource.graphql';
import NavStoreSourceREST from '../../../graphql-fragments/nav/NavStoreSource.rest.json5';
import AllSourcesGraphQL from '../../../graphql-fragments/nav/sources/AllSources.graphql';
import AllSourcesREST from '../../../graphql-fragments/nav/sources/AllSources.rest.json5';
import ProjectSummaryGraphQL from '../../../graphql-fragments/nav/sources/ProjectSummary.graphql';
import ProjectSummaryREST from '../../../graphql-fragments/nav/sources/ProjectSummary.rest.json5';
import SourceSummaryGraphQL from '../../../graphql-fragments/nav/sources/SourceSummary.graphql';
import SourceSummaryREST from '../../../graphql-fragments/nav/sources/SourceSummary.rest.json5';
import SourceSummaryWithoutRootFolderGraphQL from '../../../graphql-fragments/nav/sources/SourceSummaryWithoutRootFolder.graphql';
import SourceSummaryWithoutRootFolderREST from '../../../graphql-fragments/nav/sources/SourceSummaryWithoutRootFolder.rest.json5';
import DocumentChipGraphQL from '../../../graphql-fragments/notebook/documents/DocumentChip.graphql';
import DocumentChipOrInaccessibleGraphQL from '../../../graphql-fragments/notebook/documents/DocumentChipOrInaccessible.graphql';
import DocumentSummaryGraphQL from '../../../graphql-fragments/notebook/documents/DocumentSummary.graphql';
import EntryChipOrInaccessibleGraphQL from '../../../graphql-fragments/notebook/EntryChipOrInaccessible.graphql';
import EntrySummaryGraphQL from '../../../graphql-fragments/notebook/EntrySummary.graphql';
import EntrySummaryREST from '../../../graphql-fragments/notebook/EntrySummary.rest.json5';
import EntrySummaryOrInaccessibleGraphQL from '../../../graphql-fragments/notebook/EntrySummaryOrInaccessible.graphql';
import EntrySummaryOrInaccessibleREST from '../../../graphql-fragments/notebook/EntrySummaryOrInaccessible.rest.json5';
import ProtocolSummaryGraphQL from '../../../graphql-fragments/notebook/protocols/ProtocolSummary.graphql';
import ProtocolSummaryREST from '../../../graphql-fragments/notebook/protocols/ProtocolSummary.rest.json5';
import ReviewLifecycleReviewSummaryGraphQL from '../../../graphql-fragments/notebook/reviews/ReviewLifecycleReviewSummary.graphql';
import ReviewSummaryGraphQL from '../../../graphql-fragments/notebook/reviews/ReviewSummary.graphql';
import ReviewSummaryREST from '../../../graphql-fragments/notebook/reviews/ReviewSummary.rest.json5';
import CurrentPublishingRecordForListingPageGraphQL from '../../../graphql-fragments/notebook/template-publishing/CurrentPublishingRecordForListingPage.graphql';
import PublishingRecordForButtonGraphQL from '../../../graphql-fragments/notebook/template-publishing/PublishingRecordForButton.graphql';
import PublishingRecordForVersionHistoryPanelGraphQL from '../../../graphql-fragments/notebook/template-publishing/PublishingRecordForVersionHistoryPanel.graphql';
import PublishingRecordsForButtonGraphQL from '../../../graphql-fragments/notebook/template-publishing/PublishingRecordsForButton.graphql';
import PublishingRecordsForVersionHistoryPanelGraphQL from '../../../graphql-fragments/notebook/template-publishing/PublishingRecordsForVersionHistoryPanel.graphql';
import PublishingStatusForListingPageGraphQL from '../../../graphql-fragments/notebook/template-publishing/PublishingStatusForListingPage.graphql';
import BaseCollectibleSummaryGraphQL from '../../../graphql-fragments/notebook/templates/BaseCollectibleSummary.graphql';
import CollectibleListingGraphQL from '../../../graphql-fragments/notebook/templates/CollectibleListing.graphql';
import SubtemplateSummaryGraphQL from '../../../graphql-fragments/notebook/templates/SubtemplateSummary.graphql';
import TemplateChipGraphQL from '../../../graphql-fragments/notebook/templates/TemplateChip.graphql';
import TemplateChipOrInaccessibleGraphQL from '../../../graphql-fragments/notebook/templates/TemplateChipOrInaccessible.graphql';
import TemplateCollectionGraphQL from '../../../graphql-fragments/notebook/templates/TemplateCollection.graphql';
import TemplateCollectionListingGraphQL from '../../../graphql-fragments/notebook/templates/TemplateCollectionListing.graphql';
import TemplateCollectionPermissionsGraphQL from '../../../graphql-fragments/notebook/templates/TemplateCollectionPermissions.graphql';
import TemplateCollectionSummaryGraphQL from '../../../graphql-fragments/notebook/templates/TemplateCollectionSummary.graphql';
import TemplateSummaryGraphQL from '../../../graphql-fragments/notebook/templates/TemplateSummary.graphql';
import AuthorGraphQL from '../../../graphql-fragments/parties/Author.graphql';
import AuthorREST from '../../../graphql-fragments/parties/Author.rest.json5';
import CreatorGraphQL from '../../../graphql-fragments/parties/Creator.graphql';
import CreatorREST from '../../../graphql-fragments/parties/Creator.rest.json5';
import HasAuthorsGraphQL from '../../../graphql-fragments/parties/HasAuthors.graphql';
import HasAuthorsREST from '../../../graphql-fragments/parties/HasAuthors.rest.json5';
import HasCreatorGraphQL from '../../../graphql-fragments/parties/HasCreator.graphql';
import HasCreatorREST from '../../../graphql-fragments/parties/HasCreator.rest.json5';
import OrganizationGraphQL from '../../../graphql-fragments/parties/Organization.graphql';
import OrganizationRoleGraphQL from '../../../graphql-fragments/parties/OrganizationRole.graphql';
import PartyChipGraphQL from '../../../graphql-fragments/parties/PartyChip.graphql';
import PartyChipOrInaccessibleGraphQL from '../../../graphql-fragments/parties/PartyChipOrInaccessible.graphql';
import PartySummaryGraphQL from '../../../graphql-fragments/parties/PartySummary.graphql';
import PartySummaryREST from '../../../graphql-fragments/parties/PartySummary.rest.json5';
import PrincipalGraphQL from '../../../graphql-fragments/parties/Principal.graphql';
import PrincipalREST from '../../../graphql-fragments/parties/Principal.rest.json5';
import TeamGraphQL from '../../../graphql-fragments/parties/Team.graphql';
import TeamRoleGraphQL from '../../../graphql-fragments/parties/TeamRole.graphql';
import UserGraphQL from '../../../graphql-fragments/parties/User.graphql';
import UserAvatarInfoGraphQL from '../../../graphql-fragments/parties/UserAvatarInfo.graphql';
import BaseProcedureMethodDefinitionVersionGraphQL from '../../../graphql-fragments/procedures/BaseProcedureMethodDefinitionVersion.graphql';
import FullProcedureMethodDefinitionVersionGraphQL from '../../../graphql-fragments/procedures/FullProcedureMethodDefinitionVersion.graphql';
import LibraryParameterDefinitionGraphQL from '../../../graphql-fragments/procedures/LibraryParameterDefinition.graphql';
import ProcedureGraphQL from '../../../graphql-fragments/procedures/Procedure.graphql';
import ProcedureChipOrInaccessibleGraphQL from '../../../graphql-fragments/procedures/ProcedureChipOrInaccessible.graphql';
import ProcedureFlowchartConfigVersionProxyGraphQL from '../../../graphql-fragments/procedures/ProcedureFlowchartConfigVersionProxy.graphql';
import ProcedureFlowchartConfigVersionProxyAllFieldsGraphQL from '../../../graphql-fragments/procedures/ProcedureFlowchartConfigVersionProxyAllFields.graphql';
import ProcedureFlowchartConfigVersionProxyExperimentalInputsGraphQL from '../../../graphql-fragments/procedures/ProcedureFlowchartConfigVersionProxyExperimentalInputs.graphql';
import ProcedureFlowchartVersionGraphQL from '../../../graphql-fragments/procedures/ProcedureFlowchartVersion.graphql';
import ProcedureMethodDefinitionVersionParameterVersionsGraphQL from '../../../graphql-fragments/procedures/ProcedureMethodDefinitionVersionParameterVersions.graphql';
import ProcedureMethodExecutionInstanceGraphQL from '../../../graphql-fragments/procedures/ProcedureMethodExecutionInstance.graphql';
import ProcedureMethodExecutionInstanceChipOrInaccessibleGraphQL from '../../../graphql-fragments/procedures/ProcedureMethodExecutionInstanceChipOrInaccessible.graphql';
import ProcedureMethodExecutionInstancePlannedValuesGraphQL from '../../../graphql-fragments/procedures/ProcedureMethodExecutionInstancePlannedValues.graphql';
import ProcedureRunChipOrInaccessibleGraphQL from '../../../graphql-fragments/procedures/ProcedureRunChipOrInaccessible.graphql';
import TestDefinitionChipGraphQL from '../../../graphql-fragments/procedures/TestDefinitionChip.graphql';
import TestDefinitionChipOrInaccessibleGraphQL from '../../../graphql-fragments/procedures/TestDefinitionChipOrInaccessible.graphql';
import ProcessGraphQL from '../../../graphql-fragments/processes/Process.graphql';
import ProcessChipOrInaccessibleGraphQL from '../../../graphql-fragments/processes/ProcessChipOrInaccessible.graphql';
import ProcessEndNodeDetailsGraphQL from '../../../graphql-fragments/processes/ProcessEndNodeDetails.graphql';
import ProcessFieldDefinitionNodeForEditorGraphQL from '../../../graphql-fragments/processes/ProcessFieldDefinitionNodeForEditor.graphql';
import ProcessFlowchartGraphQL from '../../../graphql-fragments/processes/ProcessFlowchart.graphql';
import ProcessFlowchartConfigGraphQL from '../../../graphql-fragments/processes/ProcessFlowchartConfig.graphql';
import ProcessFlowchartConfigEditorGraphQL from '../../../graphql-fragments/processes/ProcessFlowchartConfigEditor.graphql';
import ProcessFlowchartConfigEditorWithDefinitionsGraphQL from '../../../graphql-fragments/processes/ProcessFlowchartConfigEditorWithDefinitions.graphql';
import ProcessFlowchartConfigEditorWithoutVersionGraphQL from '../../../graphql-fragments/processes/ProcessFlowchartConfigEditorWithoutVersion.graphql';
import ProcessFlowchartConfigForEditorWithLatestVersionGraphQL from '../../../graphql-fragments/processes/ProcessFlowchartConfigForEditorWithLatestVersion.graphql';
import ProcessFlowchartConfigUpdateResponseGraphQL from '../../../graphql-fragments/processes/ProcessFlowchartConfigUpdateResponse.graphql';
import ProcessFlowchartConfigVersionGraphQL from '../../../graphql-fragments/processes/ProcessFlowchartConfigVersion.graphql';
import ProcessFlowchartConfigVersionForEditorGraphQL from '../../../graphql-fragments/processes/ProcessFlowchartConfigVersionForEditor.graphql';
import ProcessFlowchartConfigVersionForEditorWithDefinitionsGraphQL from '../../../graphql-fragments/processes/ProcessFlowchartConfigVersionForEditorWithDefinitions.graphql';
import ProcessFlowchartConfigVersionForViewerGraphQL from '../../../graphql-fragments/processes/ProcessFlowchartConfigVersionForViewer.graphql';
import ProcessFlowchartConfigViewerGraphQL from '../../../graphql-fragments/processes/ProcessFlowchartConfigViewer.graphql';
import ProcessFlowchartConfigViewerWithoutVersionGraphQL from '../../../graphql-fragments/processes/ProcessFlowchartConfigViewerWithoutVersion.graphql';
import ProcessFlowchartForEditorGraphQL from '../../../graphql-fragments/processes/ProcessFlowchartForEditor.graphql';
import ProcessFlowchartForViewerGraphQL from '../../../graphql-fragments/processes/ProcessFlowchartForViewer.graphql';
import ProcessFlowchartNodeConfigGraphQL from '../../../graphql-fragments/processes/ProcessFlowchartNodeConfig.graphql';
import ProcessFlowchartNodeConfigForEditorGraphQL from '../../../graphql-fragments/processes/ProcessFlowchartNodeConfigForEditor.graphql';
import ProcessFlowchartNodeConfigForViewerGraphQL from '../../../graphql-fragments/processes/ProcessFlowchartNodeConfigForViewer.graphql';
import ProcessFlowchartSchemaMapperConfigForEditorGraphQL from '../../../graphql-fragments/processes/ProcessFlowchartSchemaMapperConfigForEditor.graphql';
import ProcessFlowchartSchemaMapperConfigForViewerGraphQL from '../../../graphql-fragments/processes/ProcessFlowchartSchemaMapperConfigForViewer.graphql';
import ProcessListingGraphQL from '../../../graphql-fragments/processes/ProcessListing.graphql';
import ProcessOutputGraphQL from '../../../graphql-fragments/processes/ProcessOutput.graphql';
import ProcessOutputChipOrInaccessibleGraphQL from '../../../graphql-fragments/processes/ProcessOutputChipOrInaccessible.graphql';
import ProcessOutputListingGraphQL from '../../../graphql-fragments/processes/ProcessOutputListing.graphql';
import ProcessOutputNodeDetailsGraphQL from '../../../graphql-fragments/processes/ProcessOutputNodeDetails.graphql';
import ProcessOutputRowGraphQL from '../../../graphql-fragments/processes/ProcessOutputRow.graphql';
import ProcessOutputSummaryGraphQL from '../../../graphql-fragments/processes/ProcessOutputSummary.graphql';
import ProcessRootNodeDetailsGraphQL from '../../../graphql-fragments/processes/ProcessRootNodeDetails.graphql';
import ProcessRouterNodeDetailsGraphQL from '../../../graphql-fragments/processes/ProcessRouterNodeDetails.graphql';
import ProcessSummaryGraphQL from '../../../graphql-fragments/processes/ProcessSummary.graphql';
import ProcessTaskGraphQL from '../../../graphql-fragments/processes/ProcessTask.graphql';
import ProcessTaskChipOrInaccessibleGraphQL from '../../../graphql-fragments/processes/ProcessTaskChipOrInaccessible.graphql';
import ProcessTaskDefinitionGraphQL from '../../../graphql-fragments/processes/ProcessTaskDefinition.graphql';
import ProcessTaskDefinitionForViewerGraphQL from '../../../graphql-fragments/processes/ProcessTaskDefinitionForViewer.graphql';
import ProcessTaskDefinitionVersionGraphQL from '../../../graphql-fragments/processes/ProcessTaskDefinitionVersion.graphql';
import ProcessTaskDefinitionVersionForEditorGraphQL from '../../../graphql-fragments/processes/ProcessTaskDefinitionVersionForEditor.graphql';
import ProcessTaskDefinitionVersionForViewerGraphQL from '../../../graphql-fragments/processes/ProcessTaskDefinitionVersionForViewer.graphql';
import ProcessTaskDefinitionVersionReferenceForEditorGraphQL from '../../../graphql-fragments/processes/ProcessTaskDefinitionVersionReferenceForEditor.graphql';
import ProcessTaskForCalendarGraphQL from '../../../graphql-fragments/processes/ProcessTaskForCalendar.graphql';
import ProcessTaskListingGraphQL from '../../../graphql-fragments/processes/ProcessTaskListing.graphql';
import ProcessTaskNodeDetailsGraphQL from '../../../graphql-fragments/processes/ProcessTaskNodeDetails.graphql';
import ProcessTaskPipelineInfoGraphQL from '../../../graphql-fragments/processes/ProcessTaskPipelineInfo.graphql';
import ProcessTaskProcedureInfoGraphQL from '../../../graphql-fragments/processes/ProcessTaskProcedureInfo.graphql';
import ProcessTaskRowGraphQL from '../../../graphql-fragments/processes/ProcessTaskRow.graphql';
import ProcessTaskStatusLifecycleGraphQL from '../../../graphql-fragments/processes/ProcessTaskStatusLifecycle.graphql';
import ProcessTaskSummaryGraphQL from '../../../graphql-fragments/processes/ProcessTaskSummary.graphql';
import RequestV2DefinitionGraphQL from '../../../graphql-fragments/processes/requests-v2/RequestV2Definition.graphql';
import RequestV2DefinitionListingGraphQL from '../../../graphql-fragments/processes/requests-v2/RequestV2DefinitionListing.graphql';
import RequestV2SubmissionGraphQL from '../../../graphql-fragments/processes/requests-v2/RequestV2Submission.graphql';
import RequestV2SubmissionChipGraphQL from '../../../graphql-fragments/processes/requests-v2/RequestV2SubmissionChip.graphql';
import RequestV2SubmissionChipOrInaccessibleGraphQL from '../../../graphql-fragments/processes/requests-v2/RequestV2SubmissionChipOrInaccessible.graphql';
import RequestV2SubmissionListingGraphQL from '../../../graphql-fragments/processes/requests-v2/RequestV2SubmissionListing.graphql';
import AllProcessOutputSchemasForSearchGraphQL from '../../../graphql-fragments/processes/schemas/AllProcessOutputSchemasForSearch.graphql';
import AllProcessTaskSchemasForSchemaConfigGraphQL from '../../../graphql-fragments/processes/schemas/AllProcessTaskSchemasForSchemaConfig.graphql';
import AllProcessTaskSchemasForSearchGraphQL from '../../../graphql-fragments/processes/schemas/AllProcessTaskSchemasForSearch.graphql';
import ProcessFlowchartSchemaMapperGraphQL from '../../../graphql-fragments/processes/schemas/ProcessFlowchartSchemaMapper.graphql';
import ProcessFlowchartSchemaMapperConfigGraphQL from '../../../graphql-fragments/processes/schemas/ProcessFlowchartSchemaMapperConfig.graphql';
import ProcessOutputSchemaGraphQL from '../../../graphql-fragments/processes/schemas/ProcessOutputSchema.graphql';
import ProcessTaskSchemaGraphQL from '../../../graphql-fragments/processes/schemas/ProcessTaskSchema.graphql';
import ProcessTaskSchemaForViewerGraphQL from '../../../graphql-fragments/processes/schemas/ProcessTaskSchemaForViewer.graphql';
import ProcessTaskSchemaWithoutFlowchartConfigGraphQL from '../../../graphql-fragments/processes/schemas/ProcessTaskSchemaWithoutFlowchartConfig.graphql';
import ExecutionSampleGraphQL from '../../../graphql-fragments/registry/execution-samples/ExecutionSample.graphql';
import IngredientGraphQL from '../../../graphql-fragments/registry/mixtures/Ingredient.graphql';
import MixtureGraphQL from '../../../graphql-fragments/registry/mixtures/Mixture.graphql';
import MixtureInstructionsGraphQL from '../../../graphql-fragments/registry/mixtures/MixtureInstructions.graphql';
import MixtureSpecificAttributesGraphQL from '../../../graphql-fragments/registry/mixtures/MixtureSpecificAttributes.graphql';
import MixtureSummaryGraphQL from '../../../graphql-fragments/registry/mixtures/MixtureSummary.graphql';
import MixtureSummaryREST from '../../../graphql-fragments/registry/mixtures/MixtureSummary.rest.json5';
import MixtureWithInstructionsGraphQL from '../../../graphql-fragments/registry/mixtures/MixtureWithInstructions.graphql';
import UpdateMixtureResponseGraphQL from '../../../graphql-fragments/registry/mixtures/UpdateMixtureResponse.graphql';
import RegistrationOriginGraphQL from '../../../graphql-fragments/registry/RegistrationOrigin.graphql';
import AliasesForBioentityGraphQL from '../../../graphql-fragments/registry/registry-items/AliasesForBioentity.graphql';
import AliasesForBioentityREST from '../../../graphql-fragments/registry/registry-items/AliasesForBioentity.rest.json5';
import BioentityChipOrInaccessibleGraphQL from '../../../graphql-fragments/registry/registry-items/BioentityChipOrInaccessible.graphql';
import BioentityChipSummaryGraphQL from '../../../graphql-fragments/registry/registry-items/BioentityChipSummary.graphql';
import BioentityLiveDataGraphQL from '../../../graphql-fragments/registry/registry-items/BioentityLiveData.graphql';
import BioentitySummaryGraphQL from '../../../graphql-fragments/registry/registry-items/BioentitySummary.graphql';
import BioentitySummaryREST from '../../../graphql-fragments/registry/registry-items/BioentitySummary.rest.json5';
import BioentitySummaryOrInaccessibleGraphQL from '../../../graphql-fragments/registry/registry-items/BioentitySummaryOrInaccessible.graphql';
import LookupBioentityGraphQL from '../../../graphql-fragments/registry/registry-items/LookupBioentity.graphql';
import RegistryItemGraphQL from '../../../graphql-fragments/registry/registry-items/RegistryItem.graphql';
import RegistryItemInfoGraphQL from '../../../graphql-fragments/registry/registry-items/RegistryItemInfo.graphql';
import RegistryItemListingPermissionsGraphQL from '../../../graphql-fragments/registry/registry-items/RegistryItemListingPermissions.graphql';
import RegistryItemSummaryGraphQL from '../../../graphql-fragments/registry/registry-items/RegistryItemSummary.graphql';
import RegistryItemSummaryREST from '../../../graphql-fragments/registry/registry-items/RegistryItemSummary.rest.json5';
import RegistryGraphQL from '../../../graphql-fragments/registry/Registry.graphql';
import RegistrySummaryGraphQL from '../../../graphql-fragments/registry/RegistrySummary.graphql';
import SchemaFieldSelectorsForRegistryGraphQL from '../../../graphql-fragments/registry/SchemaFieldSelectorsForRegistry.graphql';
import AllRequestTemplatesGraphQL from '../../../graphql-fragments/requests/AllRequestTemplates.graphql';
import RequestGraphQL from '../../../graphql-fragments/requests/Request.graphql';
import RequestREST from '../../../graphql-fragments/requests/Request.rest.json5';
import RequestChipOrInaccessibleGraphQL from '../../../graphql-fragments/requests/RequestChipOrInaccessible.graphql';
import RequestFulfillmentGraphQL from '../../../graphql-fragments/requests/RequestFulfillment.graphql';
import RequestTaskGraphQL from '../../../graphql-fragments/requests/RequestTask.graphql';
import RequestTaskTemplateGraphQL from '../../../graphql-fragments/requests/RequestTaskTemplate.graphql';
import RequestTemplateGraphQL from '../../../graphql-fragments/requests/RequestTemplate.graphql';
import SampleGroupGraphQL from '../../../graphql-fragments/requests/SampleGroup.graphql';
import AllRequestTaskSchemasGraphQL from '../../../graphql-fragments/requests/schemas/AllRequestTaskSchemas.graphql';
import RequestSchemaGraphQL from '../../../graphql-fragments/requests/schemas/RequestSchema.graphql';
import RequestSchemaREST from '../../../graphql-fragments/requests/schemas/RequestSchema.rest.json5';
import RequestTaskSchemaGraphQL from '../../../graphql-fragments/requests/schemas/RequestTaskSchema.graphql';
import SampleGroupSchemaGraphQL from '../../../graphql-fragments/requests/schemas/SampleGroupSchema.graphql';
import SampleGroupSchemaREST from '../../../graphql-fragments/requests/schemas/SampleGroupSchema.rest.json5';
import ResultGraphQL from '../../../graphql-fragments/results/Result.graphql';
import ResultREST from '../../../graphql-fragments/results/Result.rest.json5';
import ResultBlobGraphQL from '../../../graphql-fragments/results/ResultBlob.graphql';
import AllResultSchemasGraphQL from '../../../graphql-fragments/results/schemas/AllResultSchemas.graphql';
import ResultSchemaGraphQL from '../../../graphql-fragments/results/schemas/ResultSchema.graphql';
import ResultSchemaREST from '../../../graphql-fragments/results/schemas/ResultSchema.rest.json5';
import RunGraphQL from '../../../graphql-fragments/runs/Run.graphql';
import RunREST from '../../../graphql-fragments/runs/Run.rest.json5';
import RunChipOrInaccessibleGraphQL from '../../../graphql-fragments/runs/RunChipOrInaccessible.graphql';
import RunSchemaGraphQL from '../../../graphql-fragments/runs/schemas/RunSchema.graphql';
import RunSchemaREST from '../../../graphql-fragments/runs/schemas/RunSchema.rest.json5';
import TestDefinitionListingGraphQL from '../../../graphql-fragments/sample_tests/TestDefinitionListing.graphql';
import TestOrderChipGraphQL from '../../../graphql-fragments/sample_tests/TestOrderChip.graphql';
import TestOrderChipOrInaccessibleGraphQL from '../../../graphql-fragments/sample_tests/TestOrderChipOrInaccessible.graphql';
import TestOrderListingGraphQL from '../../../graphql-fragments/sample_tests/TestOrderListing.graphql';
import AllSchemaInterfacesGraphQL from '../../../graphql-fragments/schemas/schema-interfaces/AllSchemaInterfaces.graphql';
import SchemaInterfaceGraphQL from '../../../graphql-fragments/schemas/schema-interfaces/SchemaInterface.graphql';
import SchemaInterfaceListingGraphQL from '../../../graphql-fragments/schemas/schema-interfaces/SchemaInterfaceListing.graphql';
import SchemaInterfaceWithFieldsGraphQL from '../../../graphql-fragments/schemas/schema-interfaces/SchemaInterfaceWithFields.graphql';
import SchemaFieldSelectorGraphQL from '../../../graphql-fragments/schemas/SchemaFieldSelector.graphql';
import SchemaFieldSelectorOptionGraphQL from '../../../graphql-fragments/schemas/SchemaFieldSelectorOption.graphql';
import SchemaPermissionsGraphQL from '../../../graphql-fragments/schemas/SchemaPermissions.graphql';
import SchemaPermissionsREST from '../../../graphql-fragments/schemas/SchemaPermissions.rest.json5';
import AllCompleteTagSchemasGraphQL from '../../../graphql-fragments/schemas/tag-schemas/AllCompleteTagSchemas.graphql';
import AllTagSchemasGraphQL from '../../../graphql-fragments/schemas/tag-schemas/AllTagSchemas.graphql';
import StarredTagSchemaIdsGraphQL from '../../../graphql-fragments/schemas/tag-schemas/StarredTagSchemaIds.graphql';
import TagSchemaGraphQL from '../../../graphql-fragments/schemas/tag-schemas/TagSchema.graphql';
import TagSchemaREST from '../../../graphql-fragments/schemas/tag-schemas/TagSchema.rest.json5';
import TagSchemaChipOrInaccessibleGraphQL from '../../../graphql-fragments/schemas/tag-schemas/TagSchemaChipOrInaccessible.graphql';
import TagSchemaConstraintGraphQL from '../../../graphql-fragments/schemas/tag-schemas/TagSchemaConstraint.graphql';
import TagSchemaConstraintREST from '../../../graphql-fragments/schemas/tag-schemas/TagSchemaConstraint.rest.json5';
import TagSchemaInterfacesGraphQL from '../../../graphql-fragments/schemas/tag-schemas/TagSchemaInterfaces.graphql';
import TagSchemaSummaryGraphQL from '../../../graphql-fragments/schemas/tag-schemas/TagSchemaSummary.graphql';
import TagSchemaValidationErrorLabelSummaryGraphQL from '../../../graphql-fragments/schemas/tag-schemas/TagSchemaValidationErrorLabelSummary.graphql';
import TagSchemaValidationStatusSummaryGraphQL from '../../../graphql-fragments/schemas/tag-schemas/TagSchemaValidationStatusSummary.graphql';
import TagSchemaListingGraphQL from '../../../graphql-fragments/schemas/TagSchemaListing.graphql';
import TagSchemaListingWithFieldsGraphQL from '../../../graphql-fragments/schemas/TagSchemaListingWithFields.graphql';
import SavedSearchGraphQL from '../../../graphql-fragments/search/SavedSearch.graphql';
import SavedSearchPermissionsGraphQL from '../../../graphql-fragments/search/SavedSearchPermissions.graphql';
import AllStudySchemasGraphQL from '../../../graphql-fragments/studies/AllStudySchemas.graphql';
import SampleDefinitionGraphQL from '../../../graphql-fragments/studies/SampleDefinition.graphql';
import SampleDefinitionChipGraphQL from '../../../graphql-fragments/studies/SampleDefinitionChip.graphql';
import SampleDefinitionChipOrInaccessibleGraphQL from '../../../graphql-fragments/studies/SampleDefinitionChipOrInaccessible.graphql';
import StudyableTypedValueDataGraphQL from '../../../graphql-fragments/studies/StudyableTypedValueData.graphql';
import StudyChipOrInaccessibleGraphQL from '../../../graphql-fragments/studies/StudyChipOrInaccessible.graphql';
import StudyListingGraphQL from '../../../graphql-fragments/studies/StudyListing.graphql';
import TreatmentGroupGraphQL from '../../../graphql-fragments/studies/TreatmentGroup.graphql';
import HasAdvancedRulesGraphQL from '../../../graphql-fragments/validation-rules/HasAdvancedRules.graphql';
import HasSimpleRulesGraphQL from '../../../graphql-fragments/validation-rules/HasSimpleRules.graphql';
import StageEntryChipOrInaccessibleGraphQL from '../../../graphql-fragments/workflows/StageEntryChipOrInaccessible.graphql';
import StageEntrySummaryGraphQL from '../../../graphql-fragments/workflows/StageEntrySummary.graphql';
import WorkflowSummaryGraphQL from '../../../graphql-fragments/workflows/WorkflowSummary.graphql';
import WorklistGraphQL from '../../../graphql-fragments/worklists/Worklist.graphql';
import WorklistChipOrInaccessibleGraphQL from '../../../graphql-fragments/worklists/WorklistChipOrInaccessible.graphql';
import WorklistItemsGraphQL from '../../../graphql-fragments/worklists/WorklistItems.graphql';
import WorklistSummaryGraphQL from '../../../graphql-fragments/worklists/WorklistSummary.graphql';
import WorksheetGraphQL from '../../../graphql-fragments/worksheets/Worksheet.graphql';
import WorksheetChipGraphQL from '../../../graphql-fragments/worksheets/WorksheetChip.graphql';
import WorksheetChipOrInaccessibleGraphQL from '../../../graphql-fragments/worksheets/WorksheetChipOrInaccessible.graphql';
import WorksheetListingGraphQL from '../../../graphql-fragments/worksheets/WorksheetListing.graphql';
import {RESTSelectionSetOptions} from './Types';

export interface FragmentAndDeclaration {
  title: string;
  graphQLDoc: DocumentNode;
  restDeclaration?: RESTSelectionSetOptions;
}

export const ALL_FRAGMENTS_AND_DECLARATIONS: Array<FragmentAndDeclaration> = [
  {
    title: 'AliasesForBioentity',
    restDeclaration: AliasesForBioentityREST,
    graphQLDoc: AliasesForBioentityGraphQL,
  },
  {
    title: 'AllAssaySchemas',
    restDeclaration: AllAssaySchemasREST,
    graphQLDoc: AllAssaySchemasGraphQL,
  },
  {
    title: 'AllBoxSchemas',
    restDeclaration: AllBoxSchemasREST,
    graphQLDoc: AllBoxSchemasGraphQL,
  },
  {
    title: 'AllCompleteTagSchemas',
    graphQLDoc: AllCompleteTagSchemasGraphQL,
  },
  {
    title: 'AllContainerSchemas',
    restDeclaration: AllContainerSchemasREST,
    graphQLDoc: AllContainerSchemasGraphQL,
  },
  {
    title: 'AllLocationSchemas',
    restDeclaration: AllLocationSchemasREST,
    graphQLDoc: AllLocationSchemasGraphQL,
  },
  {
    title: 'AllPlateSchemas',
    restDeclaration: AllPlateSchemasREST,
    graphQLDoc: AllPlateSchemasGraphQL,
  },
  {
    title: 'AllProcessOutputSchemasForSearch',
    graphQLDoc: AllProcessOutputSchemasForSearchGraphQL,
  },
  {
    title: 'AllProcessTaskSchemasForSchemaConfig',
    graphQLDoc: AllProcessTaskSchemasForSchemaConfigGraphQL,
  },
  {
    title: 'AllProcessTaskSchemasForSearch',
    graphQLDoc: AllProcessTaskSchemasForSearchGraphQL,
  },
  {
    title: 'AllRequestTaskSchemas',
    graphQLDoc: AllRequestTaskSchemasGraphQL,
  },
  {
    title: 'AllRequestTemplates',
    graphQLDoc: AllRequestTemplatesGraphQL,
  },
  {
    title: 'AllResultSchemas',
    graphQLDoc: AllResultSchemasGraphQL,
  },
  {
    title: 'AllSchemaInterfaces',
    graphQLDoc: AllSchemaInterfacesGraphQL,
  },
  {
    title: 'AllSources',
    restDeclaration: AllSourcesREST,
    graphQLDoc: AllSourcesGraphQL,
  },
  {
    title: 'AllStorableSchemas',
    graphQLDoc: AllStorableSchemasGraphQL,
  },
  {
    title: 'AllStudySchemas',
    graphQLDoc: AllStudySchemasGraphQL,
  },
  {
    title: 'AllTagSchemas',
    graphQLDoc: AllTagSchemasGraphQL,
  },
  {
    title: 'AnalysisChipOrInaccessible',
    graphQLDoc: AnalysisChipOrInaccessibleGraphQL,
  },
  {
    title: 'AnalysisSearchAttributes',
    graphQLDoc: AnalysisSearchAttributesGraphQL,
  },
  {
    title: 'AnalysisTemplateChipOrInaccessible',
    graphQLDoc: AnalysisTemplateChipOrInaccessibleGraphQL,
  },
  {
    title: 'AnalyticsDashboardLink',
    graphQLDoc: AnalyticsDashboardLinkGraphQL,
  },
  {
    title: 'AnalyticsDashboardLinkParent',
    graphQLDoc: AnalyticsDashboardLinkParentGraphQL,
  },
  {
    title: 'AnalyticsDashboardListing',
    graphQLDoc: AnalyticsDashboardListingGraphQL,
  },
  {
    title: 'AnalyticsDashboardSearchAttributes',
    graphQLDoc: AnalyticsDashboardSearchAttributesGraphQL,
  },
  {
    title: 'AnalyticsParameterBioentityLinkConfig',
    graphQLDoc: AnalyticsParameterBioentityLinkConfigGraphQL,
  },
  {
    title: 'AnalyticsParameterConfig',
    graphQLDoc: AnalyticsParameterConfigGraphQL,
  },
  {
    title: 'AnalyticsParameterDateConfig',
    graphQLDoc: AnalyticsParameterDateConfigGraphQL,
  },
  {
    title: 'AnalyticsParameterEntryLinkConfig',
    graphQLDoc: AnalyticsParameterEntryLinkConfigGraphQL,
  },
  {
    title: 'AnalyticsParameterFolderLinkConfig',
    graphQLDoc: AnalyticsParameterFolderLinkConfigGraphQL,
  },
  {
    title: 'AnalyticsParameterNumberConfig',
    graphQLDoc: AnalyticsParameterNumberConfigGraphQL,
  },
  {
    title: 'AnalyticsParameterProcessLinkConfig',
    graphQLDoc: AnalyticsParameterProcessLinkConfigGraphQL,
  },
  {
    title: 'AnalyticsParameterProcessTaskLinkConfig',
    graphQLDoc: AnalyticsParameterProcessTaskLinkConfigGraphQL,
  },
  {
    title: 'AnalyticsParameterProjectLinkConfig',
    graphQLDoc: AnalyticsParameterProjectLinkConfigGraphQL,
  },
  {
    title: 'AnalyticsParameterSelectorConfig',
    graphQLDoc: AnalyticsParameterSelectorConfigGraphQL,
  },
  {
    title: 'AnalyticsParameterStorableLinkConfig',
    graphQLDoc: AnalyticsParameterStorableLinkConfigGraphQL,
  },
  {
    title: 'AnalyticsParameterStringConfig',
    graphQLDoc: AnalyticsParameterStringConfigGraphQL,
  },
  {
    title: 'AnalyticsParameterStudyLinkConfig',
    graphQLDoc: AnalyticsParameterStudyLinkConfigGraphQL,
  },
  {
    title: 'AnalyticsParameterTeamLinkConfig',
    graphQLDoc: AnalyticsParameterTeamLinkConfigGraphQL,
  },
  {
    title: 'AnalyticsParameterUserLinkConfig',
    graphQLDoc: AnalyticsParameterUserLinkConfigGraphQL,
  },
  {
    title: 'AnalyticsParameterValueTemplate',
    graphQLDoc: AnalyticsParameterValueTemplateGraphQL,
  },
  {
    title: 'AnalyticsTrackingParams',
    graphQLDoc: AnalyticsTrackingParamsGraphQL,
  },
  {
    title: 'AntibodyFormat',
    graphQLDoc: AntibodyFormatGraphQL,
  },
  {
    title: 'AntibodySchemaWithFormat',
    graphQLDoc: AntibodySchemaWithFormatGraphQL,
  },
  {
    title: 'ArchiveData',
    graphQLDoc: ArchiveDataGraphQL,
  },
  {
    title: 'ArchiveRecord',
    graphQLDoc: ArchiveRecordGraphQL,
  },
  {
    title: 'AssaySchema',
    restDeclaration: AssaySchemaREST,
    graphQLDoc: AssaySchemaGraphQL,
  },
  {
    title: 'Author',
    restDeclaration: AuthorREST,
    graphQLDoc: AuthorGraphQL,
  },
  {
    title: 'AutomationErrorFile',
    graphQLDoc: AutomationErrorFileGraphQL,
  },
  {
    title: 'AutomationInputFile',
    graphQLDoc: AutomationInputFileGraphQL,
  },
  {
    title: 'AutomationOutputFile',
    graphQLDoc: AutomationOutputFileGraphQL,
  },
  {
    title: 'AutomationOutputFileChipOrInaccessible',
    graphQLDoc: AutomationOutputFileChipOrInaccessibleGraphQL,
  },
  {
    title: 'AutomationOutputFileConfig',
    restDeclaration: AutomationOutputFileConfigREST,
    graphQLDoc: AutomationOutputFileConfigGraphQL,
  },
  {
    title: 'BaseAnalyticsParameterConfig',
    graphQLDoc: BaseAnalyticsParameterConfigGraphQL,
  },
  {
    title: 'BaseCollectibleSummary',
    graphQLDoc: BaseCollectibleSummaryGraphQL,
  },
  {
    title: 'BaseFolderItemFile',
    graphQLDoc: BaseFolderItemFileGraphQL,
  },
  {
    title: 'BasePermissions',
    graphQLDoc: BasePermissionsGraphQL,
  },
  {
    title: 'BaseProcedureMethodDefinitionVersion',
    graphQLDoc: BaseProcedureMethodDefinitionVersionGraphQL,
  },
  {
    title: 'BaseStorable',
    restDeclaration: BaseStorableREST,
    graphQLDoc: BaseStorableGraphQL,
  },
  {
    title: 'BaseStorableSchema',
    restDeclaration: BaseStorableSchemaREST,
    graphQLDoc: BaseStorableSchemaGraphQL,
  },
  {
    title: 'BaseStorableSummary',
    restDeclaration: BaseStorableSummaryREST,
    graphQLDoc: BaseStorableSummaryGraphQL,
  },
  {
    title: 'BasicFolderItem',
    graphQLDoc: BasicFolderItemGraphQL,
  },
  {
    title: 'BasicFolderItemSummary',
    restDeclaration: BasicFolderItemSummaryREST,
    graphQLDoc: BasicFolderItemSummaryGraphQL,
  },
  {
    title: 'Batch',
    graphQLDoc: BatchGraphQL,
  },
  {
    title: 'BatchSummary',
    graphQLDoc: BatchSummaryGraphQL,
  },
  {
    title: 'BenchlingApp',
    graphQLDoc: BenchlingAppGraphQL,
  },
  {
    title: 'BenchlingAppCanvas',
    graphQLDoc: BenchlingAppCanvasGraphQL,
  },
  {
    title: 'BenchlingAppConfiguration',
    graphQLDoc: BenchlingAppConfigurationGraphQL,
  },
  {
    title: 'BenchlingAppDefinition',
    graphQLDoc: BenchlingAppDefinitionGraphQL,
  },
  {
    title: 'BenchlingAppDefinitionVersions',
    graphQLDoc: BenchlingAppDefinitionVersionsGraphQL,
  },
  {
    title: 'BenchlingAppFeature',
    graphQLDoc: BenchlingAppFeatureGraphQL,
  },
  {
    title: 'BenchlingAppSession',
    graphQLDoc: BenchlingAppSessionGraphQL,
  },
  {
    title: 'BioentityChipOrInaccessible',
    graphQLDoc: BioentityChipOrInaccessibleGraphQL,
  },
  {
    title: 'BioentityChipSummary',
    graphQLDoc: BioentityChipSummaryGraphQL,
  },
  {
    title: 'BioentityLiveData',
    graphQLDoc: BioentityLiveDataGraphQL,
  },
  {
    title: 'BioentitySummary',
    restDeclaration: BioentitySummaryREST,
    graphQLDoc: BioentitySummaryGraphQL,
  },
  {
    title: 'BioentitySummaryOrInaccessible',
    graphQLDoc: BioentitySummaryOrInaccessibleGraphQL,
  },
  {
    title: 'Box',
    graphQLDoc: BoxGraphQL,
  },
  {
    title: 'BoxLiveData',
    graphQLDoc: BoxLiveDataGraphQL,
  },
  {
    title: 'BoxSchema',
    restDeclaration: BoxSchemaREST,
    graphQLDoc: BoxSchemaGraphQL,
  },
  {
    title: 'BoxSummary',
    restDeclaration: BoxSummaryREST,
    graphQLDoc: BoxSummaryGraphQL,
  },
  {
    title: 'BulkAssembly',
    graphQLDoc: BulkAssemblyGraphQL,
  },
  {
    title: 'BulkAssemblyChipOrInaccessible',
    graphQLDoc: BulkAssemblyChipOrInaccessibleGraphQL,
  },
  {
    title: 'BulkAssemblyChipSummary',
    graphQLDoc: BulkAssemblyChipSummaryGraphQL,
  },
  {
    title: 'BulkAssemblyListing',
    graphQLDoc: BulkAssemblyListingGraphQL,
  },
  {
    title: 'CanvasDefinitionFileState',
    graphQLDoc: CanvasDefinitionFileStateGraphQL,
  },
  {
    title: 'CanvasVersionFileState',
    graphQLDoc: CanvasVersionFileStateGraphQL,
  },
  {
    title: 'CollaboratorInfo',
    graphQLDoc: CollaboratorInfoGraphQL,
  },
  {
    title: 'CollectibleListing',
    graphQLDoc: CollectibleListingGraphQL,
  },
  {
    title: 'ComplexPolymer',
    graphQLDoc: ComplexPolymerGraphQL,
  },
  {
    title: 'ComplexPolymerConnection',
    graphQLDoc: ComplexPolymerConnectionGraphQL,
  },
  {
    title: 'ComplexPolymerSchemaConfiguration',
    graphQLDoc: ComplexPolymerSchemaConfigurationGraphQL,
  },
  {
    title: 'ConnectionChipOrInaccessible',
    graphQLDoc: ConnectionChipOrInaccessibleGraphQL,
  },
  {
    title: 'ConnectionListing',
    graphQLDoc: ConnectionListingGraphQL,
  },
  {
    title: 'Container',
    restDeclaration: ContainerREST,
    graphQLDoc: ContainerGraphQL,
  },
  {
    title: 'ContainerInfo',
    graphQLDoc: ContainerInfoGraphQL,
  },
  {
    title: 'ContainerSchema',
    restDeclaration: ContainerSchemaREST,
    graphQLDoc: ContainerSchemaGraphQL,
  },
  {
    title: 'ContainerSummary',
    restDeclaration: ContainerSummaryREST,
    graphQLDoc: ContainerSummaryGraphQL,
  },
  {
    title: 'CoreObjectArchivable',
    graphQLDoc: CoreObjectArchivableGraphQL,
  },
  {
    title: 'Creator',
    restDeclaration: CreatorREST,
    graphQLDoc: CreatorGraphQL,
  },
  {
    title: 'CurrentPublishingRecordForListingPage',
    graphQLDoc: CurrentPublishingRecordForListingPageGraphQL,
  },
  {
    title: 'Dataset',
    graphQLDoc: DatasetGraphQL,
  },
  {
    title: 'DatasetChip',
    graphQLDoc: DatasetChipGraphQL,
  },
  {
    title: 'DatasetChipOrInaccessible',
    graphQLDoc: DatasetChipOrInaccessibleGraphQL,
  },
  {
    title: 'DatasetListing',
    graphQLDoc: DatasetListingGraphQL,
  },
  {
    title: 'DatasetPermissions',
    graphQLDoc: DatasetPermissionsGraphQL,
  },
  {
    title: 'DefaultSchemaCollaboratorsConfiguration',
    graphQLDoc: DefaultSchemaCollaboratorsConfigurationGraphQL,
  },
  {
    title: 'DocumentChip',
    graphQLDoc: DocumentChipGraphQL,
  },
  {
    title: 'DocumentChipOrInaccessible',
    graphQLDoc: DocumentChipOrInaccessibleGraphQL,
  },
  {
    title: 'DocumentSummary',
    graphQLDoc: DocumentSummaryGraphQL,
  },
  {
    title: 'EntryChipOrInaccessible',
    graphQLDoc: EntryChipOrInaccessibleGraphQL,
  },
  {
    title: 'EntrySummary',
    restDeclaration: EntrySummaryREST,
    graphQLDoc: EntrySummaryGraphQL,
  },
  {
    title: 'EntrySummaryOrInaccessible',
    restDeclaration: EntrySummaryOrInaccessibleREST,
    graphQLDoc: EntrySummaryOrInaccessibleGraphQL,
  },
  {
    title: 'EventSubscription',
    graphQLDoc: EventSubscriptionGraphQL,
  },
  {
    title: 'ExecutionSample',
    graphQLDoc: ExecutionSampleGraphQL,
  },
  {
    title: 'File',
    graphQLDoc: FileGraphQL,
  },
  {
    title: 'FileChip',
    graphQLDoc: FileChipGraphQL,
  },
  {
    title: 'FileChipOrInaccessible',
    graphQLDoc: FileChipOrInaccessibleGraphQL,
  },
  {
    title: 'FileListing',
    graphQLDoc: FileListingGraphQL,
  },
  {
    title: 'FilePermissions',
    graphQLDoc: FilePermissionsGraphQL,
  },
  {
    title: 'Folder',
    restDeclaration: FolderREST,
    graphQLDoc: FolderGraphQL,
  },
  {
    title: 'FolderItemSummary',
    restDeclaration: FolderItemSummaryREST,
    graphQLDoc: FolderItemSummaryGraphQL,
  },
  {
    title: 'FolderSummary',
    restDeclaration: FolderSummaryREST,
    graphQLDoc: FolderSummaryGraphQL,
  },
  {
    title: 'FolderSummaryWithoutParentsWithoutSource',
    restDeclaration: FolderSummaryWithoutParentsWithoutSourceREST,
    graphQLDoc: FolderSummaryWithoutParentsWithoutSourceGraphQL,
  },
  {
    title: 'FolderSummaryWithoutSource',
    restDeclaration: FolderSummaryWithoutSourceREST,
    graphQLDoc: FolderSummaryWithoutSourceGraphQL,
  },
  {
    title: 'FolderWithPermissions',
    restDeclaration: FolderWithPermissionsREST,
    graphQLDoc: FolderWithPermissionsGraphQL,
  },
  {
    title: 'FullProcedureMethodDefinitionVersion',
    graphQLDoc: FullProcedureMethodDefinitionVersionGraphQL,
  },
  {
    title: 'Grid',
    graphQLDoc: GridGraphQL,
  },
  {
    title: 'GridCellIndexes',
    graphQLDoc: GridCellIndexesGraphQL,
  },
  {
    title: 'HasAdvancedRules',
    graphQLDoc: HasAdvancedRulesGraphQL,
  },
  {
    title: 'HasArchiveRecord',
    restDeclaration: HasArchiveRecordREST,
    graphQLDoc: HasArchiveRecordGraphQL,
  },
  {
    title: 'HasAuthors',
    restDeclaration: HasAuthorsREST,
    graphQLDoc: HasAuthorsGraphQL,
  },
  {
    title: 'HasCreator',
    restDeclaration: HasCreatorREST,
    graphQLDoc: HasCreatorGraphQL,
  },
  {
    title: 'HasListingPermissions',
    graphQLDoc: HasListingPermissionsGraphQL,
  },
  {
    title: 'HasOwnablePermissions',
    graphQLDoc: HasOwnablePermissionsGraphQL,
  },
  {
    title: 'HasSimpleRules',
    graphQLDoc: HasSimpleRulesGraphQL,
  },
  {
    title: 'ImplementedAntibodySchemaInterface',
    graphQLDoc: ImplementedAntibodySchemaInterfaceGraphQL,
  },
  {
    title: 'InaccessibleInfo',
    restDeclaration: InaccessibleInfoREST,
    graphQLDoc: InaccessibleInfoGraphQL,
  },
  {
    title: 'IndividualColumnMapping',
    graphQLDoc: IndividualColumnMappingGraphQL,
  },
  {
    title: 'Ingredient',
    graphQLDoc: IngredientGraphQL,
  },
  {
    title: 'Institution',
    graphQLDoc: InstitutionGraphQL,
  },
  {
    title: 'InventoryContainerLiveData',
    graphQLDoc: InventoryContainerLiveDataGraphQL,
  },
  {
    title: 'Jellyfish',
    graphQLDoc: JellyfishGraphQL,
  },
  {
    title: 'JellyfishFileState',
    graphQLDoc: JellyfishFileStateGraphQL,
  },
  {
    title: 'JellyfishListing',
    graphQLDoc: JellyfishListingGraphQL,
  },
  {
    title: 'JellyfishPermissions',
    graphQLDoc: JellyfishPermissionsGraphQL,
  },
  {
    title: 'LibraryParameterDefinition',
    graphQLDoc: LibraryParameterDefinitionGraphQL,
  },
  {
    title: 'ListingPermissions',
    graphQLDoc: ListingPermissionsGraphQL,
  },
  {
    title: 'Location',
    graphQLDoc: LocationGraphQL,
  },
  {
    title: 'LocationSchema',
    restDeclaration: LocationSchemaREST,
    graphQLDoc: LocationSchemaGraphQL,
  },
  {
    title: 'LocationSummary',
    restDeclaration: LocationSummaryREST,
    graphQLDoc: LocationSummaryGraphQL,
  },
  {
    title: 'LookupBioentity',
    graphQLDoc: LookupBioentityGraphQL,
  },
  {
    title: 'LookupStorable',
    graphQLDoc: LookupStorableGraphQL,
  },
  {
    title: 'Mixture',
    graphQLDoc: MixtureGraphQL,
  },
  {
    title: 'MixtureInstructions',
    graphQLDoc: MixtureInstructionsGraphQL,
  },
  {
    title: 'MixtureSpecificAttributes',
    graphQLDoc: MixtureSpecificAttributesGraphQL,
  },
  {
    title: 'MixtureSummary',
    restDeclaration: MixtureSummaryREST,
    graphQLDoc: MixtureSummaryGraphQL,
  },
  {
    title: 'MixtureWithInstructions',
    graphQLDoc: MixtureWithInstructionsGraphQL,
  },
  {
    title: 'ModifiedNucleotide',
    graphQLDoc: ModifiedNucleotideGraphQL,
  },
  {
    title: 'Molecule',
    graphQLDoc: MoleculeGraphQL,
  },
  {
    title: 'MoleculeInComplexPolymer',
    graphQLDoc: MoleculeInComplexPolymerGraphQL,
  },
  {
    title: 'MoleculeSummary',
    restDeclaration: MoleculeSummaryREST,
    graphQLDoc: MoleculeSummaryGraphQL,
  },
  {
    title: 'MoleculeVersion',
    graphQLDoc: MoleculeVersionGraphQL,
  },
  {
    title: 'NavStoreProject',
    graphQLDoc: NavStoreProjectGraphQL,
  },
  {
    title: 'NavStoreRegistry',
    restDeclaration: NavStoreRegistryREST,
    graphQLDoc: NavStoreRegistryGraphQL,
  },
  {
    title: 'NavStoreSource',
    restDeclaration: NavStoreSourceREST,
    graphQLDoc: NavStoreSourceGraphQL,
  },
  {
    title: 'NucleotideInComplexPolymer',
    graphQLDoc: NucleotideInComplexPolymerGraphQL,
  },
  {
    title: 'OligoConjugateSchemaConfiguration',
    graphQLDoc: OligoConjugateSchemaConfigurationGraphQL,
  },
  {
    title: 'OligoDuplexSchemaConfiguration',
    graphQLDoc: OligoDuplexSchemaConfigurationGraphQL,
  },
  {
    title: 'OligoStrand',
    graphQLDoc: OligoStrandGraphQL,
  },
  {
    title: 'Organization',
    graphQLDoc: OrganizationGraphQL,
  },
  {
    title: 'OrganizationRole',
    graphQLDoc: OrganizationRoleGraphQL,
  },
  {
    title: 'OwnerAndCollaboratorInfo',
    graphQLDoc: OwnerAndCollaboratorInfoGraphQL,
  },
  {
    title: 'ParentStorable',
    graphQLDoc: ParentStorableGraphQL,
  },
  {
    title: 'ParentStorableCapacity',
    graphQLDoc: ParentStorableCapacityGraphQL,
  },
  {
    title: 'PartyChip',
    graphQLDoc: PartyChipGraphQL,
  },
  {
    title: 'PartyChipOrInaccessible',
    graphQLDoc: PartyChipOrInaccessibleGraphQL,
  },
  {
    title: 'PartySummary',
    restDeclaration: PartySummaryREST,
    graphQLDoc: PartySummaryGraphQL,
  },
  {
    title: 'PersistedDataFrame',
    graphQLDoc: PersistedDataFrameGraphQL,
  },
  {
    title: 'Plate',
    graphQLDoc: PlateGraphQL,
  },
  {
    title: 'PlateLiveData',
    graphQLDoc: PlateLiveDataGraphQL,
  },
  {
    title: 'PlateSchema',
    restDeclaration: PlateSchemaREST,
    graphQLDoc: PlateSchemaGraphQL,
  },
  {
    title: 'PlateSize',
    graphQLDoc: PlateSizeGraphQL,
  },
  {
    title: 'PlateSummary',
    restDeclaration: PlateSummaryREST,
    graphQLDoc: PlateSummaryGraphQL,
  },
  {
    title: 'PlateWellInfo',
    graphQLDoc: PlateWellInfoGraphQL,
  },
  {
    title: 'PredictionBatchListing',
    graphQLDoc: PredictionBatchListingGraphQL,
  },
  {
    title: 'PredictionJobListing',
    graphQLDoc: PredictionJobListingGraphQL,
  },
  {
    title: 'Principal',
    restDeclaration: PrincipalREST,
    graphQLDoc: PrincipalGraphQL,
  },
  {
    title: 'Printer',
    graphQLDoc: PrinterGraphQL,
  },
  {
    title: 'Procedure',
    graphQLDoc: ProcedureGraphQL,
  },
  {
    title: 'ProcedureChipOrInaccessible',
    graphQLDoc: ProcedureChipOrInaccessibleGraphQL,
  },
  {
    title: 'ProcedureFlowchartConfigVersionProxy',
    graphQLDoc: ProcedureFlowchartConfigVersionProxyGraphQL,
  },
  {
    title: 'ProcedureFlowchartConfigVersionProxyAllFields',
    graphQLDoc: ProcedureFlowchartConfigVersionProxyAllFieldsGraphQL,
  },
  {
    title: 'ProcedureFlowchartConfigVersionProxyExperimentalInputs',
    graphQLDoc: ProcedureFlowchartConfigVersionProxyExperimentalInputsGraphQL,
  },
  {
    title: 'ProcedureFlowchartVersion',
    graphQLDoc: ProcedureFlowchartVersionGraphQL,
  },
  {
    title: 'ProcedureMethodDefinitionVersionParameterVersions',
    graphQLDoc: ProcedureMethodDefinitionVersionParameterVersionsGraphQL,
  },
  {
    title: 'ProcedureMethodExecutionInstance',
    graphQLDoc: ProcedureMethodExecutionInstanceGraphQL,
  },
  {
    title: 'ProcedureMethodExecutionInstanceChipOrInaccessible',
    graphQLDoc: ProcedureMethodExecutionInstanceChipOrInaccessibleGraphQL,
  },
  {
    title: 'ProcedureMethodExecutionInstancePlannedValues',
    graphQLDoc: ProcedureMethodExecutionInstancePlannedValuesGraphQL,
  },
  {
    title: 'ProcedureRunChipOrInaccessible',
    graphQLDoc: ProcedureRunChipOrInaccessibleGraphQL,
  },
  {
    title: 'Process',
    graphQLDoc: ProcessGraphQL,
  },
  {
    title: 'ProcessChipOrInaccessible',
    graphQLDoc: ProcessChipOrInaccessibleGraphQL,
  },
  {
    title: 'ProcessEndNodeDetails',
    graphQLDoc: ProcessEndNodeDetailsGraphQL,
  },
  {
    title: 'ProcessFieldDefinitionNodeForEditor',
    graphQLDoc: ProcessFieldDefinitionNodeForEditorGraphQL,
  },
  {
    title: 'ProcessFlowchart',
    graphQLDoc: ProcessFlowchartGraphQL,
  },
  {
    title: 'ProcessFlowchartConfig',
    graphQLDoc: ProcessFlowchartConfigGraphQL,
  },
  {
    title: 'ProcessFlowchartConfigEditor',
    graphQLDoc: ProcessFlowchartConfigEditorGraphQL,
  },
  {
    title: 'ProcessFlowchartConfigEditorWithDefinitions',
    graphQLDoc: ProcessFlowchartConfigEditorWithDefinitionsGraphQL,
  },
  {
    title: 'ProcessFlowchartConfigEditorWithoutVersion',
    graphQLDoc: ProcessFlowchartConfigEditorWithoutVersionGraphQL,
  },
  {
    title: 'ProcessFlowchartConfigForEditorWithLatestVersion',
    graphQLDoc: ProcessFlowchartConfigForEditorWithLatestVersionGraphQL,
  },
  {
    title: 'ProcessFlowchartConfigUpdateResponse',
    graphQLDoc: ProcessFlowchartConfigUpdateResponseGraphQL,
  },
  {
    title: 'ProcessFlowchartConfigVersion',
    graphQLDoc: ProcessFlowchartConfigVersionGraphQL,
  },
  {
    title: 'ProcessFlowchartConfigVersionForEditor',
    graphQLDoc: ProcessFlowchartConfigVersionForEditorGraphQL,
  },
  {
    title: 'ProcessFlowchartConfigVersionForEditorWithDefinitions',
    graphQLDoc: ProcessFlowchartConfigVersionForEditorWithDefinitionsGraphQL,
  },
  {
    title: 'ProcessFlowchartConfigVersionForViewer',
    graphQLDoc: ProcessFlowchartConfigVersionForViewerGraphQL,
  },
  {
    title: 'ProcessFlowchartConfigViewer',
    graphQLDoc: ProcessFlowchartConfigViewerGraphQL,
  },
  {
    title: 'ProcessFlowchartConfigViewerWithoutVersion',
    graphQLDoc: ProcessFlowchartConfigViewerWithoutVersionGraphQL,
  },
  {
    title: 'ProcessFlowchartForEditor',
    graphQLDoc: ProcessFlowchartForEditorGraphQL,
  },
  {
    title: 'ProcessFlowchartForViewer',
    graphQLDoc: ProcessFlowchartForViewerGraphQL,
  },
  {
    title: 'ProcessFlowchartNodeConfig',
    graphQLDoc: ProcessFlowchartNodeConfigGraphQL,
  },
  {
    title: 'ProcessFlowchartNodeConfigForEditor',
    graphQLDoc: ProcessFlowchartNodeConfigForEditorGraphQL,
  },
  {
    title: 'ProcessFlowchartNodeConfigForViewer',
    graphQLDoc: ProcessFlowchartNodeConfigForViewerGraphQL,
  },
  {
    title: 'ProcessFlowchartSchemaMapper',
    graphQLDoc: ProcessFlowchartSchemaMapperGraphQL,
  },
  {
    title: 'ProcessFlowchartSchemaMapperConfig',
    graphQLDoc: ProcessFlowchartSchemaMapperConfigGraphQL,
  },
  {
    title: 'ProcessFlowchartSchemaMapperConfigForEditor',
    graphQLDoc: ProcessFlowchartSchemaMapperConfigForEditorGraphQL,
  },
  {
    title: 'ProcessFlowchartSchemaMapperConfigForViewer',
    graphQLDoc: ProcessFlowchartSchemaMapperConfigForViewerGraphQL,
  },
  {
    title: 'ProcessListing',
    graphQLDoc: ProcessListingGraphQL,
  },
  {
    title: 'ProcessOutput',
    graphQLDoc: ProcessOutputGraphQL,
  },
  {
    title: 'ProcessOutputChipOrInaccessible',
    graphQLDoc: ProcessOutputChipOrInaccessibleGraphQL,
  },
  {
    title: 'ProcessOutputListing',
    graphQLDoc: ProcessOutputListingGraphQL,
  },
  {
    title: 'ProcessOutputNodeDetails',
    graphQLDoc: ProcessOutputNodeDetailsGraphQL,
  },
  {
    title: 'ProcessOutputRow',
    graphQLDoc: ProcessOutputRowGraphQL,
  },
  {
    title: 'ProcessOutputSchema',
    graphQLDoc: ProcessOutputSchemaGraphQL,
  },
  {
    title: 'ProcessOutputSummary',
    graphQLDoc: ProcessOutputSummaryGraphQL,
  },
  {
    title: 'ProcessRootNodeDetails',
    graphQLDoc: ProcessRootNodeDetailsGraphQL,
  },
  {
    title: 'ProcessRouterNodeDetails',
    graphQLDoc: ProcessRouterNodeDetailsGraphQL,
  },
  {
    title: 'ProcessSummary',
    graphQLDoc: ProcessSummaryGraphQL,
  },
  {
    title: 'ProcessTask',
    graphQLDoc: ProcessTaskGraphQL,
  },
  {
    title: 'ProcessTaskChipOrInaccessible',
    graphQLDoc: ProcessTaskChipOrInaccessibleGraphQL,
  },
  {
    title: 'ProcessTaskDefinition',
    graphQLDoc: ProcessTaskDefinitionGraphQL,
  },
  {
    title: 'ProcessTaskDefinitionForViewer',
    graphQLDoc: ProcessTaskDefinitionForViewerGraphQL,
  },
  {
    title: 'ProcessTaskDefinitionVersion',
    graphQLDoc: ProcessTaskDefinitionVersionGraphQL,
  },
  {
    title: 'ProcessTaskDefinitionVersionForEditor',
    graphQLDoc: ProcessTaskDefinitionVersionForEditorGraphQL,
  },
  {
    title: 'ProcessTaskDefinitionVersionForViewer',
    graphQLDoc: ProcessTaskDefinitionVersionForViewerGraphQL,
  },
  {
    title: 'ProcessTaskDefinitionVersionReferenceForEditor',
    graphQLDoc: ProcessTaskDefinitionVersionReferenceForEditorGraphQL,
  },
  {
    title: 'ProcessTaskForCalendar',
    graphQLDoc: ProcessTaskForCalendarGraphQL,
  },
  {
    title: 'ProcessTaskListing',
    graphQLDoc: ProcessTaskListingGraphQL,
  },
  {
    title: 'ProcessTaskNodeDetails',
    graphQLDoc: ProcessTaskNodeDetailsGraphQL,
  },
  {
    title: 'ProcessTaskPipelineInfo',
    graphQLDoc: ProcessTaskPipelineInfoGraphQL,
  },
  {
    title: 'ProcessTaskProcedureInfo',
    graphQLDoc: ProcessTaskProcedureInfoGraphQL,
  },
  {
    title: 'ProcessTaskRow',
    graphQLDoc: ProcessTaskRowGraphQL,
  },
  {
    title: 'ProcessTaskSchema',
    graphQLDoc: ProcessTaskSchemaGraphQL,
  },
  {
    title: 'ProcessTaskSchemaForViewer',
    graphQLDoc: ProcessTaskSchemaForViewerGraphQL,
  },
  {
    title: 'ProcessTaskSchemaWithoutFlowchartConfig',
    graphQLDoc: ProcessTaskSchemaWithoutFlowchartConfigGraphQL,
  },
  {
    title: 'ProcessTaskStatusLifecycle',
    graphQLDoc: ProcessTaskStatusLifecycleGraphQL,
  },
  {
    title: 'ProcessTaskSummary',
    graphQLDoc: ProcessTaskSummaryGraphQL,
  },
  {
    title: 'ProjectSummary',
    restDeclaration: ProjectSummaryREST,
    graphQLDoc: ProjectSummaryGraphQL,
  },
  {
    title: 'Protein',
    graphQLDoc: ProteinGraphQL,
  },
  {
    title: 'ProteinAlignmentSummary',
    graphQLDoc: ProteinAlignmentSummaryGraphQL,
  },
  {
    title: 'ProteinSummary',
    restDeclaration: ProteinSummaryREST,
    graphQLDoc: ProteinSummaryGraphQL,
  },
  {
    title: 'ProtocolSummary',
    restDeclaration: ProtocolSummaryREST,
    graphQLDoc: ProtocolSummaryGraphQL,
  },
  {
    title: 'PublishingRecordForButton',
    graphQLDoc: PublishingRecordForButtonGraphQL,
  },
  {
    title: 'PublishingRecordForVersionHistoryPanel',
    graphQLDoc: PublishingRecordForVersionHistoryPanelGraphQL,
  },
  {
    title: 'PublishingRecordsForButton',
    graphQLDoc: PublishingRecordsForButtonGraphQL,
  },
  {
    title: 'PublishingRecordsForVersionHistoryPanel',
    graphQLDoc: PublishingRecordsForVersionHistoryPanelGraphQL,
  },
  {
    title: 'PublishingStatusForListingPage',
    graphQLDoc: PublishingStatusForListingPageGraphQL,
  },
  {
    title: 'Reaction',
    graphQLDoc: ReactionGraphQL,
  },
  {
    title: 'RegistrationOrigin',
    graphQLDoc: RegistrationOriginGraphQL,
  },
  {
    title: 'Registry',
    graphQLDoc: RegistryGraphQL,
  },
  {
    title: 'RegistryItem',
    graphQLDoc: RegistryItemGraphQL,
  },
  {
    title: 'RegistryItemInfo',
    graphQLDoc: RegistryItemInfoGraphQL,
  },
  {
    title: 'RegistryItemListingPermissions',
    graphQLDoc: RegistryItemListingPermissionsGraphQL,
  },
  {
    title: 'RegistryItemSummary',
    restDeclaration: RegistryItemSummaryREST,
    graphQLDoc: RegistryItemSummaryGraphQL,
  },
  {
    title: 'RegistrySummary',
    graphQLDoc: RegistrySummaryGraphQL,
  },
  {
    title: 'Request',
    restDeclaration: RequestREST,
    graphQLDoc: RequestGraphQL,
  },
  {
    title: 'RequestChipOrInaccessible',
    graphQLDoc: RequestChipOrInaccessibleGraphQL,
  },
  {
    title: 'RequestFulfillment',
    graphQLDoc: RequestFulfillmentGraphQL,
  },
  {
    title: 'RequestSchema',
    restDeclaration: RequestSchemaREST,
    graphQLDoc: RequestSchemaGraphQL,
  },
  {
    title: 'RequestTask',
    graphQLDoc: RequestTaskGraphQL,
  },
  {
    title: 'RequestTaskSchema',
    graphQLDoc: RequestTaskSchemaGraphQL,
  },
  {
    title: 'RequestTaskTemplate',
    graphQLDoc: RequestTaskTemplateGraphQL,
  },
  {
    title: 'RequestTemplate',
    graphQLDoc: RequestTemplateGraphQL,
  },
  {
    title: 'RequestV2Definition',
    graphQLDoc: RequestV2DefinitionGraphQL,
  },
  {
    title: 'RequestV2DefinitionListing',
    graphQLDoc: RequestV2DefinitionListingGraphQL,
  },
  {
    title: 'RequestV2Submission',
    graphQLDoc: RequestV2SubmissionGraphQL,
  },
  {
    title: 'RequestV2SubmissionChip',
    graphQLDoc: RequestV2SubmissionChipGraphQL,
  },
  {
    title: 'RequestV2SubmissionChipOrInaccessible',
    graphQLDoc: RequestV2SubmissionChipOrInaccessibleGraphQL,
  },
  {
    title: 'RequestV2SubmissionListing',
    graphQLDoc: RequestV2SubmissionListingGraphQL,
  },
  {
    title: 'ResolvedAttachment',
    graphQLDoc: ResolvedAttachmentGraphQL,
  },
  {
    title: 'ResourceFeatureAssociation',
    graphQLDoc: ResourceFeatureAssociationGraphQL,
  },
  {
    title: 'Result',
    restDeclaration: ResultREST,
    graphQLDoc: ResultGraphQL,
  },
  {
    title: 'ResultBlob',
    graphQLDoc: ResultBlobGraphQL,
  },
  {
    title: 'ResultSchema',
    restDeclaration: ResultSchemaREST,
    graphQLDoc: ResultSchemaGraphQL,
  },
  {
    title: 'ReviewLifecycleReviewSummary',
    graphQLDoc: ReviewLifecycleReviewSummaryGraphQL,
  },
  {
    title: 'ReviewSummary',
    restDeclaration: ReviewSummaryREST,
    graphQLDoc: ReviewSummaryGraphQL,
  },
  {
    title: 'Run',
    restDeclaration: RunREST,
    graphQLDoc: RunGraphQL,
  },
  {
    title: 'RunChipOrInaccessible',
    graphQLDoc: RunChipOrInaccessibleGraphQL,
  },
  {
    title: 'RunSchema',
    restDeclaration: RunSchemaREST,
    graphQLDoc: RunSchemaGraphQL,
  },
  {
    title: 'SampleDefinition',
    graphQLDoc: SampleDefinitionGraphQL,
  },
  {
    title: 'SampleDefinitionChip',
    graphQLDoc: SampleDefinitionChipGraphQL,
  },
  {
    title: 'SampleDefinitionChipOrInaccessible',
    graphQLDoc: SampleDefinitionChipOrInaccessibleGraphQL,
  },
  {
    title: 'SampleGroup',
    graphQLDoc: SampleGroupGraphQL,
  },
  {
    title: 'SampleGroupSchema',
    restDeclaration: SampleGroupSchemaREST,
    graphQLDoc: SampleGroupSchemaGraphQL,
  },
  {
    title: 'SampleRoles',
    restDeclaration: SampleRolesREST,
    graphQLDoc: SampleRolesGraphQL,
  },
  {
    title: 'SavedSearch',
    graphQLDoc: SavedSearchGraphQL,
  },
  {
    title: 'SavedSearchPermissions',
    graphQLDoc: SavedSearchPermissionsGraphQL,
  },
  {
    title: 'SchemaFieldSelector',
    graphQLDoc: SchemaFieldSelectorGraphQL,
  },
  {
    title: 'SchemaFieldSelectorOption',
    graphQLDoc: SchemaFieldSelectorOptionGraphQL,
  },
  {
    title: 'SchemaFieldSelectorsForRegistry',
    graphQLDoc: SchemaFieldSelectorsForRegistryGraphQL,
  },
  {
    title: 'SchemaInterface',
    graphQLDoc: SchemaInterfaceGraphQL,
  },
  {
    title: 'SchemaInterfaceListing',
    graphQLDoc: SchemaInterfaceListingGraphQL,
  },
  {
    title: 'SchemaInterfaceWithFields',
    graphQLDoc: SchemaInterfaceWithFieldsGraphQL,
  },
  {
    title: 'SchemaPermissions',
    restDeclaration: SchemaPermissionsREST,
    graphQLDoc: SchemaPermissionsGraphQL,
  },
  {
    title: 'ScratchFile',
    graphQLDoc: ScratchFileGraphQL,
  },
  {
    title: 'Sequence',
    graphQLDoc: SequenceGraphQL,
  },
  {
    title: 'SequenceAnalysisSummary',
    graphQLDoc: SequenceAnalysisSummaryGraphQL,
  },
  {
    title: 'SequenceSummary',
    restDeclaration: SequenceSummaryREST,
    graphQLDoc: SequenceSummaryGraphQL,
  },
  {
    title: 'SourceSummary',
    restDeclaration: SourceSummaryREST,
    graphQLDoc: SourceSummaryGraphQL,
  },
  {
    title: 'SourceSummaryWithoutRootFolder',
    restDeclaration: SourceSummaryWithoutRootFolderREST,
    graphQLDoc: SourceSummaryWithoutRootFolderGraphQL,
  },
  {
    title: 'SpreadsheetColumnsMapping',
    graphQLDoc: SpreadsheetColumnsMappingGraphQL,
  },
  {
    title: 'StageEntryChipOrInaccessible',
    graphQLDoc: StageEntryChipOrInaccessibleGraphQL,
  },
  {
    title: 'StageEntrySummary',
    graphQLDoc: StageEntrySummaryGraphQL,
  },
  {
    title: 'Star',
    graphQLDoc: StarGraphQL,
  },
  {
    title: 'Starrable',
    graphQLDoc: StarrableGraphQL,
  },
  {
    title: 'StarredTagSchemaIds',
    graphQLDoc: StarredTagSchemaIdsGraphQL,
  },
  {
    title: 'Storable',
    graphQLDoc: StorableGraphQL,
  },
  {
    title: 'StorableChipOrInaccessible',
    graphQLDoc: StorableChipOrInaccessibleGraphQL,
  },
  {
    title: 'StorableChipSummary',
    graphQLDoc: StorableChipSummaryGraphQL,
  },
  {
    title: 'StorableSchema',
    restDeclaration: StorableSchemaREST,
    graphQLDoc: StorableSchemaGraphQL,
  },
  {
    title: 'StorableSchemaChipOrInaccessible',
    graphQLDoc: StorableSchemaChipOrInaccessibleGraphQL,
  },
  {
    title: 'StorableSummary',
    graphQLDoc: StorableSummaryGraphQL,
  },
  {
    title: 'StudyChipOrInaccessible',
    graphQLDoc: StudyChipOrInaccessibleGraphQL,
  },
  {
    title: 'StudyListing',
    graphQLDoc: StudyListingGraphQL,
  },
  {
    title: 'StudyableTypedValueData',
    graphQLDoc: StudyableTypedValueDataGraphQL,
  },
  {
    title: 'SubtemplateSummary',
    graphQLDoc: SubtemplateSummaryGraphQL,
  },
  {
    title: 'TagSchema',
    restDeclaration: TagSchemaREST,
    graphQLDoc: TagSchemaGraphQL,
  },
  {
    title: 'TagSchemaChipOrInaccessible',
    graphQLDoc: TagSchemaChipOrInaccessibleGraphQL,
  },
  {
    title: 'TagSchemaConstraint',
    restDeclaration: TagSchemaConstraintREST,
    graphQLDoc: TagSchemaConstraintGraphQL,
  },
  {
    title: 'TagSchemaInterfaces',
    graphQLDoc: TagSchemaInterfacesGraphQL,
  },
  {
    title: 'TagSchemaListing',
    graphQLDoc: TagSchemaListingGraphQL,
  },
  {
    title: 'TagSchemaListingWithFields',
    graphQLDoc: TagSchemaListingWithFieldsGraphQL,
  },
  {
    title: 'TagSchemaSummary',
    graphQLDoc: TagSchemaSummaryGraphQL,
  },
  {
    title: 'TagSchemaValidationErrorLabelSummary',
    graphQLDoc: TagSchemaValidationErrorLabelSummaryGraphQL,
  },
  {
    title: 'TagSchemaValidationStatusSummary',
    graphQLDoc: TagSchemaValidationStatusSummaryGraphQL,
  },
  {
    title: 'Team',
    graphQLDoc: TeamGraphQL,
  },
  {
    title: 'TeamRole',
    graphQLDoc: TeamRoleGraphQL,
  },
  {
    title: 'TemplateChip',
    graphQLDoc: TemplateChipGraphQL,
  },
  {
    title: 'TemplateChipOrInaccessible',
    graphQLDoc: TemplateChipOrInaccessibleGraphQL,
  },
  {
    title: 'TemplateCollection',
    graphQLDoc: TemplateCollectionGraphQL,
  },
  {
    title: 'TemplateCollectionListing',
    graphQLDoc: TemplateCollectionListingGraphQL,
  },
  {
    title: 'TemplateCollectionPermissions',
    graphQLDoc: TemplateCollectionPermissionsGraphQL,
  },
  {
    title: 'TemplateCollectionSummary',
    graphQLDoc: TemplateCollectionSummaryGraphQL,
  },
  {
    title: 'TemplateSummary',
    graphQLDoc: TemplateSummaryGraphQL,
  },
  {
    title: 'TestDefinitionChip',
    graphQLDoc: TestDefinitionChipGraphQL,
  },
  {
    title: 'TestDefinitionChipOrInaccessible',
    graphQLDoc: TestDefinitionChipOrInaccessibleGraphQL,
  },
  {
    title: 'TestDefinitionListing',
    graphQLDoc: TestDefinitionListingGraphQL,
  },
  {
    title: 'TestOrderChip',
    graphQLDoc: TestOrderChipGraphQL,
  },
  {
    title: 'TestOrderChipOrInaccessible',
    graphQLDoc: TestOrderChipOrInaccessibleGraphQL,
  },
  {
    title: 'TestOrderListing',
    graphQLDoc: TestOrderListingGraphQL,
  },
  {
    title: 'TreatmentGroup',
    graphQLDoc: TreatmentGroupGraphQL,
  },
  {
    title: 'UpdateFolderItemTagSchema',
    graphQLDoc: UpdateFolderItemTagSchemaGraphQL,
  },
  {
    title: 'UpdateFolderItemTags',
    graphQLDoc: UpdateFolderItemTagsGraphQL,
  },
  {
    title: 'UpdateMixtureResponse',
    graphQLDoc: UpdateMixtureResponseGraphQL,
  },
  {
    title: 'UpdateMoleculeVersionResponse',
    graphQLDoc: UpdateMoleculeVersionResponseGraphQL,
  },
  {
    title: 'User',
    graphQLDoc: UserGraphQL,
  },
  {
    title: 'UserAvatarInfo',
    graphQLDoc: UserAvatarInfoGraphQL,
  },
  {
    title: 'WorkflowSummary',
    graphQLDoc: WorkflowSummaryGraphQL,
  },
  {
    title: 'Worklist',
    graphQLDoc: WorklistGraphQL,
  },
  {
    title: 'WorklistChipOrInaccessible',
    graphQLDoc: WorklistChipOrInaccessibleGraphQL,
  },
  {
    title: 'WorklistItems',
    graphQLDoc: WorklistItemsGraphQL,
  },
  {
    title: 'WorklistSummary',
    graphQLDoc: WorklistSummaryGraphQL,
  },
  {
    title: 'Worksheet',
    graphQLDoc: WorksheetGraphQL,
  },
  {
    title: 'WorksheetChip',
    graphQLDoc: WorksheetChipGraphQL,
  },
  {
    title: 'WorksheetChipOrInaccessible',
    graphQLDoc: WorksheetChipOrInaccessibleGraphQL,
  },
  {
    title: 'WorksheetListing',
    graphQLDoc: WorksheetListingGraphQL,
  },
];

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface DECLARATIVE_FRAGMENT_NAME_TO_DECLARATION {
  AliasesForBioentityGraphQL: 'AliasesForBioentity';
  AllAssaySchemasGraphQL: 'AllAssaySchemas';
  AllBoxSchemasGraphQL: 'AllBoxSchemas';
  AllContainerSchemasGraphQL: 'AllContainerSchemas';
  AllLocationSchemasGraphQL: 'AllLocationSchemas';
  AllPlateSchemasGraphQL: 'AllPlateSchemas';
  AllSourcesGraphQL: 'AllSources';
  AssaySchemaGraphQL: 'AssaySchema';
  AuthorGraphQL: 'Author';
  AutomationOutputFileConfigGraphQL: 'AutomationOutputFileConfig';
  BaseStorableGraphQL: 'BaseStorable';
  BaseStorableSchemaGraphQL: 'BaseStorableSchema';
  BaseStorableSummaryGraphQL: 'BaseStorableSummary';
  BasicFolderItemSummaryGraphQL: 'BasicFolderItemSummary';
  BioentitySummaryGraphQL: 'BioentitySummary';
  BoxSchemaGraphQL: 'BoxSchema';
  BoxSummaryGraphQL: 'BoxSummary';
  ContainerGraphQL: 'Container';
  ContainerSchemaGraphQL: 'ContainerSchema';
  ContainerSummaryGraphQL: 'ContainerSummary';
  CreatorGraphQL: 'Creator';
  EntrySummaryGraphQL: 'EntrySummary';
  EntrySummaryOrInaccessibleGraphQL: 'EntrySummaryOrInaccessible';
  FolderGraphQL: 'Folder';
  FolderItemSummaryGraphQL: 'FolderItemSummary';
  FolderSummaryGraphQL: 'FolderSummary';
  FolderSummaryWithoutParentsWithoutSourceGraphQL: 'FolderSummaryWithoutParentsWithoutSource';
  FolderSummaryWithoutSourceGraphQL: 'FolderSummaryWithoutSource';
  FolderWithPermissionsGraphQL: 'FolderWithPermissions';
  HasArchiveRecordGraphQL: 'HasArchiveRecord';
  HasAuthorsGraphQL: 'HasAuthors';
  HasCreatorGraphQL: 'HasCreator';
  InaccessibleInfoGraphQL: 'InaccessibleInfo';
  LocationSchemaGraphQL: 'LocationSchema';
  LocationSummaryGraphQL: 'LocationSummary';
  MixtureSummaryGraphQL: 'MixtureSummary';
  MoleculeSummaryGraphQL: 'MoleculeSummary';
  NavStoreRegistryGraphQL: 'NavStoreRegistry';
  NavStoreSourceGraphQL: 'NavStoreSource';
  PartySummaryGraphQL: 'PartySummary';
  PlateSchemaGraphQL: 'PlateSchema';
  PlateSummaryGraphQL: 'PlateSummary';
  PrincipalGraphQL: 'Principal';
  ProjectSummaryGraphQL: 'ProjectSummary';
  ProteinSummaryGraphQL: 'ProteinSummary';
  ProtocolSummaryGraphQL: 'ProtocolSummary';
  RegistryItemSummaryGraphQL: 'RegistryItemSummary';
  RequestGraphQL: 'Request';
  RequestSchemaGraphQL: 'RequestSchema';
  ResultGraphQL: 'Result';
  ResultSchemaGraphQL: 'ResultSchema';
  ReviewSummaryGraphQL: 'ReviewSummary';
  RunGraphQL: 'Run';
  RunSchemaGraphQL: 'RunSchema';
  SampleGroupSchemaGraphQL: 'SampleGroupSchema';
  SampleRolesGraphQL: 'SampleRoles';
  SchemaPermissionsGraphQL: 'SchemaPermissions';
  SequenceSummaryGraphQL: 'SequenceSummary';
  SourceSummaryGraphQL: 'SourceSummary';
  SourceSummaryWithoutRootFolderGraphQL: 'SourceSummaryWithoutRootFolder';
  StorableSchemaGraphQL: 'StorableSchema';
  TagSchemaGraphQL: 'TagSchema';
  TagSchemaConstraintGraphQL: 'TagSchemaConstraint';
}
